import React from "react";
import Spinner from "../../components/Spinner";
import Select from "react-select";
import axios from "axios";

const API = localStorage.getItem("assethost");

// Helper regex and constants, all in this file
const emailRegex =
  /^[\w.!#$%&'*+/=?^`{|}~-]+@[a-z\d](?:[a-z\d-]{0,61}[a-z\d])?(?:\.[a-z\d](?:[a-z\d-]{0,61}[a-z\d])?)+$/i;
const emailError = "Please enter a valid email address (e.g. name@example.com)";
const phoneRegex =
  /^\+?[0-9]{1,4}?[-.\s]?\(?[0-9]{1,3}?\)?[-.\s]?[0-9]{3,4}[-.\s]?[0-9]{3,4}$/;
const phoneError = "Not a valid phone number";
const nationalIdRegex = /^\d{2}-\d{6,7}[A-Z]\d{2}$/;
const ogPlaceholder = "00-000000(0)A00";
const placeholder1 = "00-000000A00";
const placeholder2 = "00-0000000A00";

function dynamicNationalIdError(id) {
  const start = "Accepted format for national ID is ";
  let last = "";
  if (id.length >= 10 && /[A-Z]/.test(id[9])) {
    last = id + placeholder1.substring(id.length);
  } else if (id.length >= 10) {
    last = id + placeholder2.substring(id.length);
  } else {
    last = id + ogPlaceholder.substring(id.length);
  }
  return start + last;
}

function formatNationalId(e, currentState, field, isZimbabwean = true) {
  let currentValue = String(currentState[field] || "");
  let newValue = currentValue;
  let newPlaceholder =
    currentValue + ogPlaceholder.substring(currentValue.length);
  let error = "";
  e = e.toUpperCase();
  if (!isZimbabwean) {
    const newState = { ...currentState, [field]: e };
    return { newPlaceholder, error, newState };
  }
  if (e.length > currentValue.length && nationalIdRegex.test(currentValue)) {
    return { newPlaceholder, error, newState: currentState };
  }
  if (nationalIdRegex.test(e)) {
    newValue = e;
    newPlaceholder = e;
  } else if (
    nationalIdRegex.test(e + placeholder1.substring(e.length)) ||
    nationalIdRegex.test(e + placeholder2.substring(e.length))
  ) {
    if (e.length >= 10) {
      if (/[A-Z]/.test(e[9])) {
        newValue = e;
        newPlaceholder = e + placeholder1.substring(e.length);
      } else {
        newValue = e;
        newPlaceholder = e + placeholder2.substring(e.length);
      }
    } else if (e.length === 2 && currentValue.length < 2) {
      newValue = e + "-";
      newPlaceholder = newValue + ogPlaceholder.substring(newValue.length);
    } else {
      newValue = e;
      newPlaceholder = e + ogPlaceholder.substring(e.length);
    }
  } else {
    error = dynamicNationalIdError(currentValue);
  }
  const newState = { ...currentState, [field]: newValue };
  return { newPlaceholder, error, newState };
}

export default class UpdateProfile extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      valid: true,
      msg: "",
      toastColor: "",
      userType: "",
      profile: null,
      // Individual fields (flattened)
      firstName: "",
      middleName: "",
      surname: "",
      nationalIdNumber: "",
      passportNumber: "",
      cellPhone: "",
      gender: "",
      email: "",
      mobileMoneyNumber: "",
      nationality: "",
      houseNumberStreet: "",
      suburb: "",
      townCityId: 0,
      isPaidService: "",
      // Company fields (flattened)
      companyName: "",
      tradingName: "",
      registrationNumber: "",
      physicalAddress: "",
      primaryContactFirstName: "",
      primaryContactSurname: "",
      primaryContactRole: "",
      primaryContactEmail: "",
      primaryContactNumber: "",
      primaryContactNationality: "",
      primaryContactIdNumber: "",
      primaryContactPassportNumber: "",
      primaryContactIdentificationDocument: null,
      primaryContactPassportDocument: null,
      billingContactFirstName: "",
      billingContactSurname: "",
      billingContactRole: "",
      billingContactEmail: "",
      billingContactNumber: "",
      billingContactNationality: "",
      billingContactIdNumber: "",
      billingContactPassportNumber: "",
      billingContactIdentificationDocument: null,
      billingContactPassportDocument: null,
      certificateOfIncorporation: null,
      cr14: null,
      // Insurance fields
      insuranceName: "",
      insuranceRegistrationNumber: "",
      insuranceAddress1: "",
      insuranceAddress2: "",
      insuranceTownCityId: 0,
      insuranceContactFirstname: "",
      insuranceContactSurname: "",
      insuranceContactRole: "",
      insuranceContactEmail: "",
      insuranceContactCellphone: "",
      insuranceContactNationality: "",
      insuranceContactIdentification: "",
      insuranceContactPassportNumber: "",
      insuranceContactIdentificationDocument: null,
      insuranceContactPassportDocument: null,
      insuranceCertificateOfIncorporation: null,
      insuranceCr14: null,
      // Law Enforcement fields
      // firstName: "",
      // middleName: "",
      // surname: "",
      forceNumber: "",
      rankId: 0,
      stationId: 0,
      roleId: 0,
      lawEnforcementNationality: "",
      lawEnforcementNationalIdNumber: "",
      lawEnforcementPassportNumber: "",
      lawEnforcementCellPhone: "",
      lawEnforcementGender: "",
      lawEnforcementOtpCode: "",
      lawEnforcementOtpId: null,
      // Traders Channel Partner fields (similar to company)
      tradersName: "",
      tradersTradingName: "",
      tradersRegistrationNumber: "",
      tradersCountry: "",
      tradersTownCityId: 0,
      tradersPhysicalAddress: "",
      tradersPrimaryContactFirstname: "",
      tradersPrimaryContactSurname: "",
      tradersPrimaryContactRole: "",
      tradersPrimaryContactEmail: "",
      tradersPrimaryContactCellphone: "",
      tradersPrimaryContactNationality: "",
      tradersPrimaryContactIdentification: "",
      tradersPrimaryContactPassportNumber: "",
      tradersPrimaryContactIdentificationDocument: null,
      tradersPrimaryContactPassportDocument: null,
      tradersBillingContactFirstname: "",
      tradersBillingContactSurname: "",
      tradersBillingContactRole: "",
      tradersBillingContactEmail: "",
      tradersBillingContactCellphone: "",
      tradersBillingContactNationality: "",
      tradersBillingContactIdentification: "",
      tradersBillingContactPassportNumber: "",
      tradersBillingContactIdentificationDocument: null,
      tradersBillingContactPassportDocument: null,
      tradersCertificateOfIncorporation: null,
      tradersCr14: null,
      // Lookup data
      lookupData: {
        countrys: [],
        townCitys: [],
        genders: ["Male", "Female", "Other"],
        serviceTypes: ["FREE", "PAID"],
      },
      // Law enforcement specific lookup data
      lawEnforcementLookupData: {
        ranks: [],
        stations: [],
        roles: [],
      },
      idPlaceholderPrimary: ogPlaceholder,
      idPlaceholderBilling: ogPlaceholder,
      idPlaceholderIndividual: ogPlaceholder,
      errors: {},

      // Document states
      documents: {
        individualNationalId: null,
        individualPassport: null,
        corporatePrimaryContactNationalId: null,
        corporatePrimaryContactPassport: null,
        corporateBillingContactNationalId: null,
        corporateBillingContactPassport: null,
        corporateCR14: null,
        corporateCertificateOfIncorporation: null,
        lawEnforcementNationalId: null,
      },

      // Existing document info
      existingDocuments: {
        individualNationalId: null,
        individualPassport: null,
        corporatePrimaryContactNationalId: null,
        corporatePrimaryContactPassport: null,
        corporateBillingContactNationalId: null,
        corporateBillingContactPassport: null,
        corporateCR14: null,
        corporateCertificateOfIncorporation: null,
        lawEnforcementNationalId: null,
      },

      // Upload states
      uploading: {},
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSelect = this.handleSelect.bind(this);
    this.handlePrimaryNationalId = this.handlePrimaryNationalId.bind(this);
    this.handleBillingNationalId = this.handleBillingNationalId.bind(this);
    this.validate = this.validate.bind(this);
    this.handleUpdate = this.handleUpdate.bind(this);
    this.loadProfile = this.loadProfile.bind(this);
    this.loadLookupData = this.loadLookupData?.bind(this);
    this.isZimbabweanPrimary = this.isZimbabweanPrimary.bind(this);
    this.isZimbabweanBilling = this.isZimbabweanBilling.bind(this);
    this.isZimbabweanIndividual = this.isZimbabweanIndividual.bind(this);

    // Document upload methods
    this.handleFileChange = this.handleFileChange.bind(this);
    this.handleUpload = this.handleUpload.bind(this);
    this.fetchExistingDocuments = this.fetchExistingDocuments.bind(this);
    this.getDocumentTypeFromParam = this.getDocumentTypeFromParam.bind(this);
    this.shouldShowDocument = this.shouldShowDocument.bind(this);
  }

  componentDidMount() {
    const token = sessionStorage.getItem("token");
    if (!token) {
      this.setState({
        loading: false,
        msg: "No user session/token. Please login.",
        toastColor: "danger",
      });
      sessionStorage.clear();
      window.href = `/?redirectUrl=${window.location.pathname + window.location.search
        }`;
      return;
    }
    let search = window.location.search;
    let params = new URLSearchParams(search);
    let userId =
      this.props.id || params.get("id") || sessionStorage.getItem("userId");
    if (!userId) {
      this.setState({
        loading: false,
        msg: "No user ID found.",
        toastColor: "danger",
      });
      return;
    }
    this.loadProfile(userId, token);
  }

  loadProfile(userId, token) {
    this.setState({ loading: true, msg: "", toastColor: "" });
    axios
      .get(API + `/users/${userId}/profile`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        const p = response.data || {};
        this.setState({
          profile: p,
          loading: false,
        });
        let type = p.profileType;
        if (!type) {
          if (p.individualProfile) type = "INDIVIDUAL";
          else if (p.companyProfile) type = "COMPANY";
          else if (p.insuranceProfile) type = "INSURANCE";
          else if (p.lawEnforcementProfile) type = "LAW_ENFORCEMENT";
          else if (p.tradersChannelPartnerProfile)
            type = "TRADERS_CHANNEL_PARTNER";
          else type = "INDIVIDUAL"; // default
        }
        this.setState({ userType: type });
        if (type === "INDIVIDUAL" && p.individualProfile) {
          const i = p.individualProfile || {};
          const nationalityStr =
            i.nationality && typeof i.nationality === "object"
              ? i.nationality.label || i.nationality.value || ""
              : i.nationality || "";
          this.setState({
            firstName: i.firstName || "",
            middleName: i.middleName || "",
            surname: i.surname || "",
            nationalIdNumber: i.nationalIdNumber || "",
            passportNumber: i.passportNumber || "",
            cellPhone: i.cellPhone || "",
            gender: i.gender || "",
            email: i.email || "",
            mobileMoneyNumber: i.mobileMoneyNumber || "",
            nationality: nationalityStr,
            houseNumberStreet: i.houseNumberStreet || "",
            suburb: i.suburb || "",
            townCityId: i.townCityId || 0,
            isPaidService: p.isPaidService || "",
          });
        } else if (type === "COMPANY" && p.companyProfile) {
          const c = p.companyProfile || {};
          this.setState({
            companyName: c.companyName || "",
            tradingName: c.tradingName || "",
            registrationNumber: c.registrationNumber || "",
            physicalAddress: c.physicalAddress || "",
            primaryContactFirstName: c.primaryContactFirstName || "",
            primaryContactSurname: c.primaryContactSurname || "",
            primaryContactRole: c.primaryContactRole || "",
            primaryContactEmail: c.primaryContactEmail || "",
            primaryContactNumber: c.primaryContactNumber || "",
            primaryContactNationality: "", // Load from lookup or assume
            primaryContactIdNumber: c.primaryContactIdNumber || "",
            primaryContactPassportNumber: c.primaryContactPassportNumber || "",
            primaryContactIdentificationDocument: null,
            primaryContactPassportDocument: null,
            billingContactFirstName: c.billingContactFirstName || "",
            billingContactSurname: c.billingContactSurname || "",
            billingContactRole: c.billingContactRole || "",
            billingContactEmail: c.billingContactEmail || "",
            billingContactNumber: c.billingContactNumber || "",
            billingContactNationality: "", // Load from lookup
            billingContactIdNumber: c.billingContactIdNumber || "",
            billingContactPassportNumber: c.billingContactPassportNumber || "",
            billingContactIdentificationDocument: null,
            billingContactPassportDocument: null,
            certificateOfIncorporation: null,
            cr14: null,
          });
        } else if (type === "INSURANCE" && p.insuranceProfile) {
          const ins = p.insuranceProfile || {};
          this.setState({
            insuranceName: ins.companyName || "",
            insuranceRegistrationNumber: ins.registrationNumber || "",
            insuranceAddress1: ins.address1 || "",
            insuranceAddress2: ins.address2 || "",
            insuranceTownCityId: ins.townCityId || 0,
            insuranceContactFirstname: ins.contactFirstname || "",
            insuranceContactSurname: ins.contactSurname || "",
            insuranceContactRole: ins.contactRole || "",
            insuranceContactEmail: ins.contactEmail || "",
            insuranceContactCellphone: ins.contactCellphone || "",
            insuranceContactNationality: "", // Load from lookup
            insuranceContactIdentification: ins.contactIdentification || "",
            insuranceContactPassportNumber: ins.contactPassportNumber || "",
            insuranceContactIdentificationDocument: null,
            insuranceContactPassportDocument: null,
            insuranceCertificateOfIncorporation: null,
            insuranceCr14: null,
          });
        } else if (type === "LAW_ENFORCEMENT" && p.lawEnforcementProfile) {
          const le = p.lawEnforcementProfile || {};
          this.setState({
            firstName: le.firstName || "",
            middleName: le.middleName || "",
            surname: le.surname || "",
            forceNumber: le.forceNumber || "",
            rankId: le.rankId || 0,
            stationId: le.stationId || 0,
            roleId: le.roleId || 0,
            lawEnforcementNationality: "", // Load from lookup
            lawEnforcementNationalIdNumber: le.nationalIdNumber || "",
            lawEnforcementPassportNumber: le.passportNumber || "",
            lawEnforcementCellPhone: le.cellPhone || "",
            lawEnforcementGender: le.gender || "",
          });
        } else if (
          type === "TRADERS_CHANNEL_PARTNER" &&
          p.tradersChannelPartnerProfile
        ) {
          const tcp = p.tradersChannelPartnerProfile || {};
          this.setState({
            tradersName: tcp.companyName || "",
            tradersTradingName: tcp.tradingName || "",
            tradersRegistrationNumber: tcp.registrationNumber || "",
            tradersCountry: tcp.country || "",
            tradersTownCityId: tcp.townCityId || 0,
            tradersPhysicalAddress: tcp.physicalAddress || "",
            tradersPrimaryContactFirstname: tcp.primaryContactFirstname || "",
            tradersPrimaryContactSurname: tcp.primaryContactSurname || "",
            tradersPrimaryContactRole: tcp.primaryContactRole || "",
            tradersPrimaryContactEmail: tcp.primaryContactEmail || "",
            tradersPrimaryContactCellphone: tcp.primaryContactCellphone || "",
            tradersPrimaryContactNationality: "", // Load from lookup
            tradersPrimaryContactIdentification:
              tcp.primaryContactIdentification || "",
            tradersPrimaryContactPassportNumber:
              tcp.primaryContactPassportNumber || "",
            tradersPrimaryContactIdentificationDocument: null,
            tradersPrimaryContactPassportDocument: null,
            tradersBillingContactFirstname: tcp.billingContactFirstname || "",
            tradersBillingContactSurname: tcp.billingContactSurname || "",
            tradersBillingContactRole: tcp.billingContactRole || "",
            tradersBillingContactEmail: tcp.billingContactEmail || "",
            tradersBillingContactCellphone: tcp.billingContactCellphone || "",
            tradersBillingContactNationality: "", // Load from lookup
            tradersBillingContactIdentification:
              tcp.billingContactIdentification || "",
            tradersBillingContactPassportNumber:
              tcp.billingContactPassportNumber || "",
            tradersBillingContactIdentificationDocument: null,
            tradersBillingContactPassportDocument: null,
            tradersCertificateOfIncorporation: null,
            tradersCr14: null,
          });
        }
        // Load lookup after type is set
        this.loadLookupData(token, type);

        // Fetch existing documents
        this.fetchExistingDocuments(token);
      })
      .catch((error) => {
        if (Number(error.status) === 403) {
          sessionStorage.clear();
          window.href = `/?redirectUrl=${window.location.pathname + window.location.search
            }`;
        }
        this.setState({
          loading: false,
          msg: error?.response?.data?.message || "Failed to load profile.",
          toastColor: "danger",
        });
      })
      .finally(() => {
        this.setState({ loading: false });
        this.validate();
      });
  }

  loadLookupData(token, type) {
    let endpoint =
      type === "INDIVIDUAL"
        ? "/register/getindividualdropdownlists"
        : "/register/getcompanydropdownlists";

    // Load law enforcement specific dropdowns
    if (type === "LAW_ENFORCEMENT") {
      this.loadLawEnforcementLookupData(token);
    }

    axios
      .get(API + endpoint, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        this.setState({ lookupData: response.data || {} });
      })
      .catch(() => {
        // Default empty arrays
        this.setState({
          lookupData: {
            countrys: [],
            townCitys: [],
            genders: type === "INDIVIDUAL" ? ["Male", "Female", "Other"] : [],
          },
        });
      });
  }

  loadLawEnforcementLookupData(token) {
    axios
      .get(API + "/law-enforcement/register/dropdownlists", {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        this.setState({
          lawEnforcementLookupData: {
            ranks: response.data?.rankList || [],
            stations: response.data?.stationList || [],
            roles: response.data?.roleList || [],
          },
        });
      })
      .catch(() => {
        // Default empty arrays
        this.setState({
          lawEnforcementLookupData: {
            ranks: [],
            stations: [],
            roles: [],
          },
        });
      });
  }

  getDocumentTypeFromParam() {
    const { userType } = this.state;

    // Map user types to document types
    switch (userType) {
      case "INDIVIDUAL":
        return "INDIVIDUAL_IDENTITY";
      case "COMPANY":
        return "CORPORATE_IDENTITY";
      case "LAW_ENFORCEMENT":
        return "LAW_ENFORCEMENT_IDENTITY";
      default:
        return "ALL";
    }
  }

  shouldShowDocument(documentKey) {
    const { userType } = this.state;
    const specificType = this.getDocumentTypeFromParam();

    // If showing all documents, check user types
    if (specificType === "ALL") {
      if (documentKey.startsWith("individual") && userType !== "INDIVIDUAL")
        return false;
      if (documentKey.startsWith("corporate") && userType !== "COMPANY")
        return false;
      if (
        documentKey.startsWith("lawEnforcement") &&
        userType !== "LAW_ENFORCEMENT"
      )
        return false;
      return true;
    }

    // Show specific document types based on user type
    switch (specificType) {
      case "INDIVIDUAL_IDENTITY":
        return (
          documentKey === "individualNationalId" ||
          documentKey === "individualPassport"
        );
      case "CORPORATE_IDENTITY":
        return (
          documentKey.includes("corporatePrimaryContact") ||
          documentKey.includes("corporateBillingContact") ||
          documentKey === "corporateCR14" ||
          documentKey === "corporateCertificateOfIncorporation"
        );
      case "LAW_ENFORCEMENT_IDENTITY":
        return documentKey === "lawEnforcementNationalId";
      default:
        return false;
    }
  }

  fetchExistingDocuments(token) {
    this.setState({ loading: true });

    const { userType, profile } = this.state;
    const promises = [];

    // Get profile IDs based on user type
    let individualProfileId = 0;
    let companyProfileId = 0;
    let lawEnforcementProfileId = 0;

    if (userType === "INDIVIDUAL" && profile?.individualProfile?.id) {
      individualProfileId = profile.individualProfile.id;
    } else if (userType === "COMPANY" && profile?.companyProfile?.id) {
      companyProfileId = profile.companyProfile.id;
    } else if (userType === "LAW_ENFORCEMENT" && profile?.lawEnforcementProfile?.id) {
      lawEnforcementProfileId = profile.lawEnforcementProfile.id;
    }

    // Fetch individual documents
    if (individualProfileId > 0) {
      promises.push(
        axios
          .get(`${API}/profile/individual/documents/${individualProfileId}`, {
            headers: { Authorization: `Bearer ${token}` },
          })
          .then((response) => ({
            type: "individual",
            data: response.data,
          }))
          .catch(() => ({ type: "individual", data: null }))
      );
    }

    // Fetch corporate documents
    if (companyProfileId > 0) {
      promises.push(
        axios
          .get(`${API}/profile/corporate/documents/${companyProfileId}`, {
            headers: { Authorization: `Bearer ${token}` },
          })
          .then((response) => ({
            type: "corporate",
            data: response.data,
          }))
          .catch(() => ({ type: "corporate", data: null }))
      );
    }

    // Fetch law enforcement documents
    if (lawEnforcementProfileId > 0) {
      promises.push(
        axios
          .get(
            `${API}/profile/lawenforcement/documents/${lawEnforcementProfileId}`,
            {
              headers: { Authorization: `Bearer ${token}` },
            }
          )
          .then((response) => ({
            type: "lawEnforcement",
            data: response.data,
          }))
          .catch(() => ({ type: "lawEnforcement", data: null }))
      );
    }

    Promise.all(promises)
      .then((results) => {
        const existingDocuments = { ...this.state.existingDocuments };

        results.forEach((result) => {
          if (result.data) {
            switch (result.type) {
              case "individual":
                existingDocuments.individualNationalId =
                  result.data.nationalIdDocument;
                existingDocuments.individualPassport =
                  result.data.passportDocument;
                break;
              case "corporate":
                existingDocuments.corporatePrimaryContactNationalId =
                  result.data.primaryContactNationalIdDocument;
                existingDocuments.corporatePrimaryContactPassport =
                  result.data.primaryContactPassportDocument;
                existingDocuments.corporateBillingContactNationalId =
                  result.data.billingContactNationalIdDocument;
                existingDocuments.corporateBillingContactPassport =
                  result.data.billingContactPassportDocument;
                existingDocuments.corporateCR14 = result.data.cr14Document;
                existingDocuments.corporateCertificateOfIncorporation =
                  result.data.certificateOfIncorporationDocument;
                break;
              case "lawEnforcement":
                existingDocuments.lawEnforcementNationalId =
                  result.data.nationalIdDocument;
                break;
              default:
                break;
            }
          }
        });

        this.setState({ existingDocuments, loading: false });
      })
      .catch((error) => {
        this.setState({
          loading: false,
          msg:
            error?.response?.data?.message ||
            "Failed to load existing documents.",
          toastColor: "danger",
        });
      });
  }

  handleFileChange(documentKey, file) {
    this.setState((prevState) => ({
      documents: {
        ...prevState.documents,
        [documentKey]: file,
      },
      errors: {
        ...prevState.errors,
        [documentKey]: null,
      },
    }));
  }

  handleUpload(documentKey) {
    const token = sessionStorage.getItem("token");
    const file = this.state.documents[documentKey];

    if (!file) {
      this.setState((prevState) => ({
        errors: {
          ...prevState.errors,
          [documentKey]: "Please select a file to upload",
        },
      }));
      return;
    }

    if (!token) {
      this.setState({
        msg: "No user session/token. Please login.",
        toastColor: "danger",
      });
      return;
    }

    this.setState((prevState) => ({
      uploading: {
        ...prevState.uploading,
        [documentKey]: true,
      },
      msg: "",
      toastColor: "",
    }));

    const formData = new FormData();
    formData.append("document", file);

    // Determine upload endpoint based on document type
    let endpoint = "";
    let profileId = 0;
    let userId = parseInt(sessionStorage.getItem("userId")) || 0;

    // eslint-disable-next-line no-unused-vars
    // const { userType, profile } = this.state;
    // if (documentKey.startsWith("individual")) {
    //   endpoint = `/profile/individual/upload-document`;
    //   profileId = this.state.individualProfileId;
    // } else if (documentKey.startsWith("corporate")) {
    //   endpoint = `/profile/corporate/upload-document`;
    //   profileId = this.state.companyProfileId;
    // } else if (documentKey.startsWith("lawEnforcement")) {
    //   endpoint = `/profile/lawenforcement/upload-document`;
    //   profileId = this.state.lawEnforcementProfileId;
    // }

    formData.append("profileId", profileId);
    formData.append("documentType", documentKey);
    formData.append("systemMessageType", this.getDocumentTypeFromParam())

    endpoint = `/users/${userId}/update-document/MISSING_IDENTITY_DOCUMENTS`

    axios
      .post(`${API}${endpoint}`, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => {
        if (response.data.success) {
          this.setState((prevState) => ({
            msg: `${this.getDocumentDisplayName(
              documentKey
            )} uploaded successfully!`,
            toastColor: "success",
            documents: {
              ...prevState.documents,
              [documentKey]: null,
            },
            existingDocuments: {
              ...prevState.existingDocuments,
              [documentKey]: response.data.document,
            },
          }));

          // Reset file input
          const fileInput = document.getElementById(`file-${documentKey}`);
          if (fileInput) fileInput.value = "";
        } else {
          this.setState({
            msg:
              response.data.message ||
              `Failed to upload ${this.getDocumentDisplayName(documentKey)}`,
            toastColor: "danger",
          });
        }
      })
      .catch((error) => {
        if (Number(error.status) === 403) {
          sessionStorage.clear();
          window.location.href = `/?redirectUrl=${window.location.pathname + window.location.search
            }`;
        }
        this.setState({
          msg:
            error?.response?.data?.message ||
            `Failed to upload ${this.getDocumentDisplayName(
              documentKey
            )}. Please try again.`,
          toastColor: "danger",
        });
      })
      .finally(() => {
        this.setState((prevState) => ({
          uploading: {
            ...prevState.uploading,
            [documentKey]: false,
          },
        }));
      });
  }

  getDocumentDisplayName(documentKey) {
    const names = {
      individualNationalId: "Individual National ID",
      individualPassport: "Individual Passport",
      corporatePrimaryContactNationalId:
        "Corporate Primary Contact National ID",
      corporatePrimaryContactPassport: "Corporate Primary Contact Passport",
      corporateBillingContactNationalId:
        "Corporate Billing Contact National ID",
      corporateBillingContactPassport: "Corporate Billing Contact Passport",
      corporateCR14: "Corporate CR14",
      corporateCertificateOfIncorporation:
        "Corporate Certificate of Incorporation",
      lawEnforcementNationalId: "Law Enforcement National ID",
    };
    return names[documentKey] || documentKey;
  }

  renderDocumentField(documentKey) {
    const { documents, existingDocuments, uploading, errors } = this.state;
    const displayName = this.getDocumentDisplayName(documentKey);
    const existingDoc = existingDocuments[documentKey];
    const isUploading = uploading[documentKey];
    const error = errors[documentKey];

    return (
      <div key={documentKey} className="form-blue-card mt-3">
        <div className="form-blue-card-grid space-y-3">
          <div className="col-span-2 font-bold">{displayName}</div>

          {existingDoc ? (
            <div className="col-span-2">
              <div className="flex items-center justify-between p-3 bg-green-50 border border-green-200 rounded">
                <div className="flex items-center">
                  <i className="bi bi-check-circle-fill text-green-500 mr-2"></i>
                  <span className="text-green-700">
                    Document uploaded:{" "}
                    {existingDoc.originalName || "Document.pdf"}
                  </span>
                  {existingDoc.uploadDate && (
                    <span className="text-sm text-gray-500 ml-2">
                      ({new Date(existingDoc.uploadDate).toLocaleDateString()})
                    </span>
                  )}
                </div>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={() => {
                    // Reset existing document to allow new upload
                    this.setState((prevState) => ({
                      existingDocuments: {
                        ...prevState.existingDocuments,
                        [documentKey]: null,
                      },
                    }));
                  }}
                >
                  Change
                </button>
              </div>
            </div>
          ) : (
            <>
              <div className="input-group">
                <label
                  htmlFor={`file-${documentKey}`}
                  className="input-group-text"
                >
                  Select Document
                </label>
                <input
                  id={`file-${documentKey}`}
                  type="file"
                  className={`form-control ${error ? " !border-red-500" : ""}`}
                  accept=".pdf,.jpg,.jpeg,.png,.gif"
                  onChange={(e) =>
                    this.handleFileChange(documentKey, e.target.files[0])
                  }
                />
                {error && <span className="input-group-error">{error}</span>}
              </div>

              <div className="flex justify-end">
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={() => this.handleUpload(documentKey)}
                  disabled={isUploading || !documents[documentKey]}
                >
                  {isUploading ? (
                    <>
                      <i className="bi bi-arrow-clockwise animate-spin mr-2"></i>
                      Uploading...
                    </>
                  ) : (
                    <>
                      <i className="bi bi-upload mr-2"></i>
                      Upload
                    </>
                  )}
                </button>
              </div>
            </>
          )}
        </div>
      </div>
    );
  }

  isZimbabweanIndividual() {
    return this.state.nationality === "ZW";
  }

  isZimbabweanPrimary() {
    return this.state.primaryContactNationality === "ZW";
  }

  isZimbabweanBilling() {
    return this.state.billingContactNationality === "ZW";
  }

  handleChange(e) {
    const { name, value, type, files } = e.target;
    const newValue = type === "file" ? (files && files[0]) || null : value;
    this.setState({ [name]: newValue }, this.validate);
  }

  handleSelect(name, value) {
    this.setState({ [name]: value }, this.validate);
  }

  handleIndividualNationalId(e, field = "nationalIdNumber") {
    const { newPlaceholder, error, newState } = formatNationalId(
      e,
      this.state,
      field,
      this.isZimbabweanIndividual()
    );
    this.setState(
      {
        [field]: newState[field],
        ...(this.isZimbabweanIndividual()
          ? { idPlaceholderIndividual: newPlaceholder }
          : {}),
        errors: { ...this.state.errors, [field]: error },
      },
      this.validate
    );
  }

  handlePrimaryNationalId(e, field = "primaryContactIdNumber") {
    const { newPlaceholder, error, newState } = formatNationalId(
      e,
      this.state,
      field,
      this.isZimbabweanPrimary()
    );
    this.setState(
      {
        [field]: newState[field],
        idPlaceholderPrimary: newPlaceholder,
        errors: { ...this.state.errors, primaryContactIdNumber: error },
      },
      this.validate
    );
  }

  handleBillingNationalId(e, field = "billingContactIdNumber") {
    const { newPlaceholder, error, newState } = formatNationalId(
      e,
      this.state,
      field,
      this.isZimbabweanBilling()
    );
    this.setState(
      {
        [field]: newState[field],
        idPlaceholderBilling: newPlaceholder,
        errors: { ...this.state.errors, billingContactIdNumber: error },
      },
      this.validate
    );
  }

  validate() {
    const s = this.state;
    let errors = {};
    let valid = true;

    if (s.userType === "INDIVIDUAL") {
      // Individual validation - explicit ifs
      if (!s.firstName || !s.firstName.trim()) {
        errors.firstName = "Firstname is required";
        valid = false;
      }
      if (!s.surname || !s.surname.trim()) {
        errors.surname = "Surname is required";
        valid = false;
      }
      if (!s.nationality || !s.nationality.trim()) {
        errors.nationality = "Nationality is required";
        valid = false;
      }
      if (this.isZimbabweanIndividual()) {
        if (!s.nationalIdNumber || !s.nationalIdNumber.trim()) {
          errors.nationalIdNumber = "National ID is required";
          valid = false;
        } else if (!nationalIdRegex.test(s.nationalIdNumber)) {
          errors.nationalIdNumber = dynamicNationalIdError(s.nationalIdNumber);
          valid = false;
        }
      } else {
        if (!s.passportNumber || !s.passportNumber.trim()) {
          errors.passportNumber = "Passport Number is required";
          valid = false;
        }
      }
      if (!s.houseNumberStreet || !s.houseNumberStreet.trim()) {
        errors.houseNumberStreet = "House No & Street is required";
        valid = false;
      }
      if (!s.suburb || !s.suburb.trim()) {
        errors.suburb = "Suburb is required";
        valid = false;
      }
      if (!s.townCityId || s.townCityId === 0) {
        errors.townCityId = "Town/City is required";
        valid = false;
      }
      if (!s.gender || !s.gender.trim()) {
        errors.gender = "Gender is required";
        valid = false;
      }
      if (!s.cellPhone || !s.cellPhone.trim()) {
        errors.cellPhone = "Cellphone is required";
        valid = false;
      } else if (!phoneRegex.test(s.cellPhone)) {
        errors.cellPhone = phoneError;
        valid = false;
      }
      if (s.email && !emailRegex.test(s.email)) {
        errors.email = emailError;
        valid = false;
      }
      if (s.isPaidService === "YES") {
        if (!s.mobileMoneyNumber || !s.mobileMoneyNumber.trim()) {
          errors.mobileMoneyNumber = "Mobile Money Number is required";
          valid = false;
        }
      }
    } else if (s.userType === "COMPANY") {
      // Company validation - explicit ifs
      if (!s.companyName || !s.companyName.trim()) {
        errors.companyName = "Company Name is required";
        valid = false;
      }
      if (!s.registrationNumber || !s.registrationNumber.trim()) {
        errors.registrationNumber = "Registration Number is required";
        valid = false;
      }
      if (!s.physicalAddress || !s.physicalAddress.trim()) {
        errors.physicalAddress = "Physical Address is required";
        valid = false;
      }
      if (!s.townCityId || s.townCityId === 0) {
        errors.townCityId = "Town/City is required";
        valid = false;
      }
      // Primary Contact
      if (!s.primaryContactFirstName || !s.primaryContactFirstName.trim()) {
        errors.primaryContactFirstName =
          "Primary Contact Firstname is required";
        valid = false;
      }
      if (!s.primaryContactSurname || !s.primaryContactSurname.trim()) {
        errors.primaryContactSurname = "Primary Contact Surname is required";
        valid = false;
      }
      if (!s.primaryContactRole || !s.primaryContactRole.trim()) {
        errors.primaryContactRole = "Primary Contact Role is required";
        valid = false;
      }
      if (!s.primaryContactEmail || !s.primaryContactEmail.trim()) {
        errors.primaryContactEmail = "Primary Contact Email is required";
        valid = false;
      } else if (!emailRegex.test(s.primaryContactEmail)) {
        errors.primaryContactEmail = emailError;
        valid = false;
      }
      if (!s.primaryContactNumber || !s.primaryContactNumber.trim()) {
        errors.primaryContactNumber = "Primary Contact Number is required";
        valid = false;
      } else if (!phoneRegex.test(s.primaryContactNumber)) {
        errors.primaryContactNumber = phoneError;
        valid = false;
      }
      if (!s.primaryContactNationality || !s.primaryContactNationality.trim()) {
        errors.primaryContactNationality =
          "Primary Contact Nationality is required";
        valid = false;
      }
      if (this.isZimbabweanPrimary()) {
        if (!s.primaryContactIdNumber || !s.primaryContactIdNumber.trim()) {
          errors.primaryContactIdNumber =
            "Primary Contact National ID is required";
          valid = false;
        } else if (!nationalIdRegex.test(s.primaryContactIdNumber)) {
          errors.primaryContactIdNumber = dynamicNationalIdError(
            s.primaryContactIdNumber
          );
          valid = false;
        }
      } else {
        if (
          !s.primaryContactPassportNumber ||
          !s.primaryContactPassportNumber.trim()
        ) {
          errors.primaryContactPassportNumber =
            "Primary Contact Passport Number is required";
          valid = false;
        }
      }
      // Billing Contact
      if (!s.billingContactFirstName || !s.billingContactFirstName.trim()) {
        errors.billingContactFirstName =
          "Billing Contact Firstname is required";
        valid = false;
      }
      if (!s.billingContactSurname || !s.billingContactSurname.trim()) {
        errors.billingContactSurname = "Billing Contact Surname is required";
        valid = false;
      }
      if (!s.billingContactRole || !s.billingContactRole.trim()) {
        errors.billingContactRole = "Billing Contact Role is required";
        valid = false;
      }
      if (!s.billingContactEmail || !s.billingContactEmail.trim()) {
        errors.billingContactEmail = "Billing Contact Email is required";
        valid = false;
      } else if (!emailRegex.test(s.billingContactEmail)) {
        errors.billingContactEmail = emailError;
        valid = false;
      }
      if (!s.billingContactNumber || !s.billingContactNumber.trim()) {
        errors.billingContactNumber = "Billing Contact Number is required";
        valid = false;
      } else if (!phoneRegex.test(s.billingContactNumber)) {
        errors.billingContactNumber = phoneError;
        valid = false;
      }
      if (!s.billingContactNationality || !s.billingContactNationality.trim()) {
        errors.billingContactNationality =
          "Billing Contact Nationality is required";
        valid = false;
      }
      if (this.isZimbabweanBilling()) {
        if (!s.billingContactIdNumber || !s.billingContactIdNumber.trim()) {
          errors.billingContactIdNumber =
            "Billing Contact National ID is required";
          valid = false;
        } else if (!nationalIdRegex.test(s.billingContactIdNumber)) {
          errors.billingContactIdNumber = dynamicNationalIdError(
            s.billingContactIdNumber
          );
          valid = false;
        }
      } else {
        if (
          !s.billingContactPassportNumber ||
          !s.billingContactPassportNumber.trim()
        ) {
          errors.billingContactPassportNumber =
            "Billing Contact Passport Number is required";
          valid = false;
        }
      }
    } else if (s.userType === "INSURANCE") {
      // Insurance validation
      if (!s.insuranceName || !s.insuranceName.trim()) {
        errors.insuranceName = "Name is required";
        valid = false;
      }
      if (
        !s.insuranceRegistrationNumber ||
        !s.insuranceRegistrationNumber.trim()
      ) {
        errors.insuranceRegistrationNumber = "Registration No is required";
        valid = false;
      }
      if (!s.insuranceAddress1 || !s.insuranceAddress1.trim()) {
        errors.insuranceAddress1 = "Address 1 is required";
        valid = false;
      }
      if (!s.insuranceTownCityId || s.insuranceTownCityId === 0) {
        errors.insuranceTownCityId = "Town/City is required";
        valid = false;
      }
      if (!s.insuranceContactFirstname || !s.insuranceContactFirstname.trim()) {
        errors.insuranceContactFirstname = "Contact Firstname is required";
        valid = false;
      }
      if (!s.insuranceContactSurname || !s.insuranceContactSurname.trim()) {
        errors.insuranceContactSurname = "Contact Surname is required";
        valid = false;
      }
      if (!s.insuranceContactRole || !s.insuranceContactRole.trim()) {
        errors.insuranceContactRole = "Contact Role is required";
        valid = false;
      }
      if (!s.insuranceContactEmail || !s.insuranceContactEmail.trim()) {
        errors.insuranceContactEmail = "Contact Email is required";
        valid = false;
      } else if (!emailRegex.test(s.insuranceContactEmail)) {
        errors.insuranceContactEmail = emailError;
        valid = false;
      }
      if (!s.insuranceContactCellphone || !s.insuranceContactCellphone.trim()) {
        errors.insuranceContactCellphone = "Contact Cellphone is required";
        valid = false;
      } else if (!phoneRegex.test(s.insuranceContactCellphone)) {
        errors.insuranceContactCellphone = phoneError;
        valid = false;
      }
      if (
        !s.insuranceContactNationality ||
        !s.insuranceContactNationality.trim()
      ) {
        errors.insuranceContactNationality = "Contact Nationality is required";
        valid = false;
      }
      if (s.insuranceContactNationality === "ZW") {
        if (
          !s.insuranceContactIdentification ||
          !s.insuranceContactIdentification.trim()
        ) {
          errors.insuranceContactIdentification =
            "Contact National ID is required";
          valid = false;
        } else if (!nationalIdRegex.test(s.insuranceContactIdentification)) {
          errors.insuranceContactIdentification = dynamicNationalIdError(
            s.insuranceContactIdentification
          );
          valid = false;
        }
      } else {
        if (
          !s.insuranceContactPassportNumber ||
          !s.insuranceContactPassportNumber.trim()
        ) {
          errors.insuranceContactPassportNumber =
            "Contact Passport Number is required";
          valid = false;
        }
      }
    } else if (s.userType === "LAW_ENFORCEMENT") {
      // Law Enforcement validation
      if (!s.firstName || !s.firstName.trim()) {
        errors.firstName = "First Name is required";
        valid = false;
      }
      if (!s.surname || !s.surname.trim()) {
        errors.surname = "Surname is required";
        valid = false;
      }
      if (!s.forceNumber || !s.forceNumber.trim()) {
        errors.forceNumber = "Force Number is required";
        valid = false;
      }
      if (!s.rankId || s.rankId === 0) {
        errors.rankId = "Rank is required";
        valid = false;
      }
      if (!s.stationId || s.stationId === 0) {
        errors.stationId = "Station is required";
        valid = false;
      }
      if (!s.roleId || s.roleId === 0) {
        errors.roleId = "Role is required";
        valid = false;
      }
      if (!s.lawEnforcementNationality || !s.lawEnforcementNationality.trim()) {
        errors.lawEnforcementNationality = "Nationality is required";
        valid = false;
      }
      if (s.lawEnforcementNationality === "ZW") {
        if (
          !s.lawEnforcementNationalIdNumber ||
          !s.lawEnforcementNationalIdNumber.trim()
        ) {
          errors.lawEnforcementNationalIdNumber = "National ID is required";
          valid = false;
        } else if (!nationalIdRegex.test(s.lawEnforcementNationalIdNumber)) {
          errors.lawEnforcementNationalIdNumber = dynamicNationalIdError(
            s.lawEnforcementNationalIdNumber
          );
          valid = false;
        }
      } else {
        if (
          !s.lawEnforcementPassportNumber ||
          !s.lawEnforcementPassportNumber.trim()
        ) {
          errors.lawEnforcementPassportNumber = "Passport Number is required";
          valid = false;
        }
      }
      if (!s.lawEnforcementCellPhone || !s.lawEnforcementCellPhone.trim()) {
        errors.lawEnforcementCellPhone = "Cellphone is required";
        valid = false;
      } else if (!phoneRegex.test(s.lawEnforcementCellPhone)) {
        errors.lawEnforcementCellPhone = phoneError;
        valid = false;
      }
      if (!s.lawEnforcementGender || !s.lawEnforcementGender.trim()) {
        errors.lawEnforcementGender = "Gender is required";
        valid = false;
      }
    } else if (s.userType === "TRADERS_CHANNEL_PARTNER") {
      // Traders Channel Partner validation (similar to company)
      if (!s.tradersName || !s.tradersName.trim()) {
        errors.tradersName = "Name is required";
        valid = false;
      }
      if (!s.tradersRegistrationNumber || !s.tradersRegistrationNumber.trim()) {
        errors.tradersRegistrationNumber = "Registration No is required";
        valid = false;
      }
      if (!s.tradersPhysicalAddress || !s.tradersPhysicalAddress.trim()) {
        errors.tradersPhysicalAddress = "Physical Address is required";
        valid = false;
      }
      if (!s.tradersCountry || !s.tradersCountry.trim()) {
        errors.tradersCountry = "Country is required";
        valid = false;
      }
      if (!s.tradersTownCityId || s.tradersTownCityId === 0) {
        errors.tradersTownCityId = "Town/City is required";
        valid = false;
      }
      // Primary Contact
      if (
        !s.tradersPrimaryContactFirstname ||
        !s.tradersPrimaryContactFirstname.trim()
      ) {
        errors.tradersPrimaryContactFirstname =
          "Primary Contact Firstname is required";
        valid = false;
      }
      if (
        !s.tradersPrimaryContactSurname ||
        !s.tradersPrimaryContactSurname.trim()
      ) {
        errors.tradersPrimaryContactSurname =
          "Primary Contact Surname is required";
        valid = false;
      }
      if (!s.tradersPrimaryContactRole || !s.tradersPrimaryContactRole.trim()) {
        errors.tradersPrimaryContactRole = "Primary Contact Role is required";
        valid = false;
      }
      if (
        !s.tradersPrimaryContactEmail ||
        !s.tradersPrimaryContactEmail.trim()
      ) {
        errors.tradersPrimaryContactEmail = "Primary Contact Email is required";
        valid = false;
      } else if (!emailRegex.test(s.tradersPrimaryContactEmail)) {
        errors.tradersPrimaryContactEmail = emailError;
        valid = false;
      }
      if (
        !s.tradersPrimaryContactCellphone ||
        !s.tradersPrimaryContactCellphone.trim()
      ) {
        errors.tradersPrimaryContactCellphone =
          "Primary Contact Cellphone is required";
        valid = false;
      } else if (!phoneRegex.test(s.tradersPrimaryContactCellphone)) {
        errors.tradersPrimaryContactCellphone = phoneError;
        valid = false;
      }
      if (
        !s.tradersPrimaryContactNationality ||
        !s.tradersPrimaryContactNationality.trim()
      ) {
        errors.tradersPrimaryContactNationality =
          "Primary Contact Nationality is required";
        valid = false;
      }
      if (s.tradersPrimaryContactNationality === "ZW") {
        if (
          !s.tradersPrimaryContactIdentification ||
          !s.tradersPrimaryContactIdentification.trim()
        ) {
          errors.tradersPrimaryContactIdentification =
            "Primary Contact National ID is required";
          valid = false;
        } else if (
          !nationalIdRegex.test(s.tradersPrimaryContactIdentification)
        ) {
          errors.tradersPrimaryContactIdentification = dynamicNationalIdError(
            s.tradersPrimaryContactIdentification
          );
          valid = false;
        }
      } else {
        if (
          !s.tradersPrimaryContactPassportNumber ||
          !s.tradersPrimaryContactPassportNumber.trim()
        ) {
          errors.tradersPrimaryContactPassportNumber =
            "Primary Contact Passport Number is required";
          valid = false;
        }
      }
      // Billing Contact
      if (
        !s.tradersBillingContactFirstname ||
        !s.tradersBillingContactFirstname.trim()
      ) {
        errors.tradersBillingContactFirstname =
          "Billing Contact Firstname is required";
        valid = false;
      }
      if (
        !s.tradersBillingContactSurname ||
        !s.tradersBillingContactSurname.trim()
      ) {
        errors.tradersBillingContactSurname =
          "Billing Contact Surname is required";
        valid = false;
      }
      if (!s.tradersBillingContactRole || !s.tradersBillingContactRole.trim()) {
        errors.tradersBillingContactRole = "Billing Contact Role is required";
        valid = false;
      }
      if (
        !s.tradersBillingContactEmail ||
        !s.tradersBillingContactEmail.trim()
      ) {
        errors.tradersBillingContactEmail = "Billing Contact Email is required";
        valid = false;
      } else if (!emailRegex.test(s.tradersBillingContactEmail)) {
        errors.tradersBillingContactEmail = emailError;
        valid = false;
      }
      if (
        !s.tradersBillingContactCellphone ||
        !s.tradersBillingContactCellphone.trim()
      ) {
        errors.tradersBillingContactCellphone =
          "Billing Contact Cellphone is required";
        valid = false;
      } else if (!phoneRegex.test(s.tradersBillingContactCellphone)) {
        errors.tradersBillingContactCellphone = phoneError;
        valid = false;
      }
      if (
        !s.tradersBillingContactNationality ||
        !s.tradersBillingContactNationality.trim()
      ) {
        errors.tradersBillingContactNationality =
          "Billing Contact Nationality is required";
        valid = false;
      }
      if (s.tradersBillingContactNationality === "ZW") {
        if (
          !s.tradersBillingContactIdentification ||
          !s.tradersBillingContactIdentification.trim()
        ) {
          errors.tradersBillingContactIdentification =
            "Billing Contact National ID is required";
          valid = false;
        } else if (
          !nationalIdRegex.test(s.tradersBillingContactIdentification)
        ) {
          errors.tradersBillingContactIdentification = dynamicNationalIdError(
            s.tradersBillingContactIdentification
          );
          valid = false;
        }
      } else {
        if (
          !s.tradersBillingContactPassportNumber ||
          !s.tradersBillingContactPassportNumber.trim()
        ) {
          errors.tradersBillingContactPassportNumber =
            "Billing Contact Passport Number is required";
          valid = false;
        }
      }
    }
    this.setState({ errors, valid });
    return valid;
  }

  handleUpdate(e) {
    if (e) e.preventDefault();
    const token = sessionStorage.getItem("token");
    if (!token) {
      this.setState({
        msg: "No user session/token. Please login.",
        toastColor: "danger",
      });
      sessionStorage.clear();
      window.href = `/?redirectUrl=${window.location.pathname + window.location.search
        }`;
      return;
    }
    this.setState({ loading: true, msg: "", toastColor: "" });
    if (!this.validate()) {
      this.setState({
        msg: "Fix the errors above and try again.",
        toastColor: "danger",
        loading: false,
      });
      return;
    }
    const s = this.state;
    const self = this;
    if (s.userType === "INDIVIDUAL") {
      const request = {
        user: {
          fullName: [s.firstName, s.middleName, s.surname]
            .filter(Boolean)
            .join(" "),
          userType: "INDIVIDUAL",
          activeStatus: "YES",
          isPaidService: s.isPaidService,
        },
        profile: {
          firstName: s.firstName,
          middleName: s.middleName,
          surname: s.surname,
          nationalIdNumber: s.nationalIdNumber,
          passportNumber: s.passportNumber,
          cellPhone: s.cellPhone,
          gender: s.gender,
          email: s.email,
          mobileMoneyNumber: s.mobileMoneyNumber,
          nationality: s.nationality,
          houseNumberStreet: s.houseNumberStreet,
          suburb: s.suburb,
          townCityId: s.townCityId,
        },
      };
      axios
        .post(API + `/users/${sessionStorage.getItem('userId') || 0}/profile-update`, request, {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then((response) => {
          if (response.data.success) {
            self.setState({
              msg: "Profile updated successfully!",
              toastColor: "success",
              loading: false,
            });
            setTimeout(() => {
              window.history.back();
            }, 1500);
          } else {
            self.setState({
              msg: response.data.message || "Update failed",
              toastColor: "danger",
              loading: false,
            });
          }
        })
        .catch((error) => {
          if (Number(error.status) === 403) {
            sessionStorage.clear();
            window.href = `/?redirectUrl=${window.location.pathname + window.location.search
              }`;
          }
          self.setState({
            msg:
              error?.response?.data?.message ||
              "Update failed. Please try again.",
            toastColor: "danger",
            loading: false,
          });
        });
    } else if (s.userType === "COMPANY") {
      let request = new FormData();
      request.append(
        "user.fullName",
        [s.primaryContactFirstName, s.primaryContactSurname].join(" ")
      );
      request.append("user.userType", "COMPANY");
      request.append("user.activeStatus", "YES");
      request.append("profile.companyName", s.companyName);
      request.append("profile.tradingName", s.tradingName || "");
      request.append("profile.registrationNumber", s.registrationNumber);
      request.append("profile.townCityId", String(s.townCityId));
      request.append("profile.physicalAddress", s.physicalAddress);
      request.append(
        "profile.primaryContactFirstName",
        s.primaryContactFirstName
      );
      request.append("profile.primaryContactSurname", s.primaryContactSurname);
      request.append(
        "profile.primaryContactIdNumber",
        s.primaryContactIdNumber || ""
      );
      request.append(
        "profile.primaryPassportNumber",
        s.primaryContactPassportNumber || ""
      );
      request.append("profile.primaryContactRole", s.primaryContactRole);
      request.append("profile.primaryContactNumber", s.primaryContactNumber);
      request.append("profile.primaryContactEmail", s.primaryContactEmail);
      request.append(
        "profile.billingContactFirstName",
        s.billingContactFirstName
      );
      request.append("profile.billingContactSurname", s.billingContactSurname);
      request.append(
        "profile.billingContactIdNumber",
        s.billingContactIdNumber || ""
      );
      request.append(
        "profile.billingContactPassportNumber",
        s.billingContactPassportNumber || ""
      );
      request.append("profile.billingContactRole", s.billingContactRole);
      request.append("profile.billingContactNumber", s.billingContactNumber);
      request.append("profile.billingContactEmail", s.billingContactEmail);
      request.append("profile.companyType", "CORPORATE");
      if (s.primaryContactIdentificationDocument) {
        request.append(
          "primaryContactIdentityDocument",
          s.primaryContactIdentificationDocument
        );
      }
      if (s.primaryContactPassportDocument) {
        request.append(
          "primaryContactPassportDocument",
          s.primaryContactPassportDocument
        );
      }
      if (s.billingContactIdentificationDocument) {
        request.append(
          "billingContactIdentificationDocument",
          s.billingContactIdentificationDocument
        );
      }
      if (s.billingContactPassportDocument) {
        request.append(
          "billingContactPassportDocument",
          s.billingContactPassportDocument
        );
      }
      if (s.certificateOfIncorporation) {
        request.append("certificateIncorpFile", s.certificateOfIncorporation);
      }
      if (s.cr14) {
        request.append("cr14File", s.cr14);
      }

      // Add document uploads
      const { documents } = s;
      if (documents.corporatePrimaryContactNationalId) {
        request.append("primaryContactIdentityDocument", documents.corporatePrimaryContactNationalId);
      }
      if (documents.corporatePrimaryContactPassport) {
        request.append("primaryContactPassportDocument", documents.corporatePrimaryContactPassport);
      }
      if (documents.corporateBillingContactNationalId) {
        request.append("billingContactIdentificationDocument", documents.corporateBillingContactNationalId);
      }
      if (documents.corporateBillingContactPassport) {
        request.append("billingContactPassportDocument", documents.corporateBillingContactPassport);
      }
      if (documents.corporateCR14) {
        request.append("cr14File", documents.corporateCR14);
      }
      if (documents.corporateCertificateOfIncorporation) {
        request.append("certificateIncorpFile", documents.corporateCertificateOfIncorporation);
      }
      axios
        .put(API + "/profile/updateCompany", request, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          if (response.data.success) {
            self.setState({
              msg: "Profile updated successfully!",
              toastColor: "success",
              loading: false,
            });
            setTimeout(() => {
              window.history.back();
            }, 1500);
          } else {
            self.setState({
              msg: response.data.message || "Update failed",
              toastColor: "danger",
              loading: false,
            });
          }
        })
        .catch((error) => {
          if (Number(error.status) === 403) {
            sessionStorage.clear();
            window.href = `/?redirectUrl=${window.location.pathname + window.location.search
              }`;
          }
          self.setState({
            msg:
              error?.response?.data?.message ||
              "Update failed. Please try again.",
            toastColor: "danger",
            loading: false,
          });
        });
    } else if (s.userType === "INSURANCE") {
      let request = new FormData();
      request.append("user.userType", "COMPANY");
      request.append(
        "user.fullName",
        [s.insuranceContactFirstname, s.insuranceContactSurname].join(" ")
      );
      request.append("user.activeStatus", "YES");
      request.append("profile.companyName", s.insuranceName);
      request.append(
        "profile.registrationNumber",
        s.insuranceRegistrationNumber
      );
      request.append("profile.townCityId", String(s.insuranceTownCityId));
      request.append(
        "profile.physicalAddress",
        [s.insuranceAddress1, s.insuranceAddress2].filter(Boolean).join(", ")
      );
      request.append(
        "profile.primaryContactFirstName",
        s.insuranceContactFirstname
      );
      request.append(
        "profile.primaryContactSurname",
        s.insuranceContactSurname
      );
      request.append("profile.primaryContactRole", s.insuranceContactRole);
      request.append(
        "profile.primaryContactIdNumber",
        s.insuranceContactIdentification || ""
      );
      request.append(
        "profile.primaryPassportNumber",
        s.insuranceContactPassportNumber || ""
      );
      request.append(
        "profile.primaryContactNumber",
        s.insuranceContactCellphone
      );
      request.append("profile.primaryContactEmail", s.insuranceContactEmail);
      request.append("profile.companyType", "INSURANCE");
      if (s.insuranceContactIdentificationDocument) {
        request.append(
          "primaryContactIdentityDocument",
          s.insuranceContactIdentificationDocument
        );
      }
      if (s.insuranceContactPassportDocument) {
        request.append(
          "primaryContactPassportDocument",
          s.insuranceContactPassportDocument
        );
      }
      if (s.insuranceCertificateOfIncorporation) {
        request.append(
          "certificateIncorpFile",
          s.insuranceCertificateOfIncorporation
        );
      }
      if (s.insuranceCr14) {
        request.append("cr14File", s.insuranceCr14);
      }

      // Add document uploads
      const { documents } = s;
      if (documents.corporatePrimaryContactNationalId) {
        request.append("primaryContactIdentityDocument", documents.corporatePrimaryContactNationalId);
      }
      if (documents.corporatePrimaryContactPassport) {
        request.append("primaryContactPassportDocument", documents.corporatePrimaryContactPassport);
      }
      if (documents.corporateCR14) {
        request.append("cr14File", documents.corporateCR14);
      }
      if (documents.corporateCertificateOfIncorporation) {
        request.append("certificateIncorpFile", documents.corporateCertificateOfIncorporation);
      }
      axios
        .put(API + "/insurance/update", request, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          if (response.data.success) {
            self.setState({
              msg: "Profile updated successfully!",
              toastColor: "success",
              loading: false,
            });
            setTimeout(() => {
              window.history.back();
            }, 1500);
          } else {
            self.setState({
              msg: response.data.message || "Update failed",
              toastColor: "danger",
              loading: false,
            });
          }
        })
        .catch((error) => {
          if (Number(error.status) === 403) {
            sessionStorage.clear();
            window.href = `/?redirectUrl=${window.location.pathname + window.location.search
              }`;
          }
          self.setState({
            msg:
              error?.response?.data?.message ||
              "Update failed. Please try again.",
            toastColor: "danger",
            loading: false,
          });
        });
    } else if (s.userType === "LAW_ENFORCEMENT") {
      const request = {
        user: {
          userType: "LAW_ENFORCEMENT",
          fullName: [s.firstName, s.middleName, s.surname]
            .filter(Boolean)
            .join(" "),
          activeStatus: "YES",
          roleId: s.roleId,
        },
        lawEnforcementProfile: {
          firstName: s.firstName,
          surname: s.surname,
          middleName: s.middleName,
          forceNumber: s.forceNumber,
          rankId: s.rankId,
          stationId: s.stationId,
          nationalIdNumber: s.lawEnforcementNationalIdNumber,
          passportNumber: s.lawEnforcementPassportNumber,
          nationality: s.lawEnforcementNationality,
          cellPhone: s.lawEnforcementCellPhone,
          gender: s.lawEnforcementGender,
        },
      };
      axios
        .put(API + "/law-enforcement/update", request, {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then((response) => {
          if (response.data.success) {
            self.setState({
              msg: "Profile updated successfully!",
              toastColor: "success",
              loading: false,
            });
            setTimeout(() => {
              window.history.back();
            }, 1500);
          } else {
            self.setState({
              msg: response.data.message || "Update failed",
              toastColor: "danger",
              loading: false,
            });
          }
        })
        .catch((error) => {
          if (Number(error.status) === 403) {
            sessionStorage.clear();
            window.href = `/?redirectUrl=${window.location.pathname + window.location.search
              }`;
          }
          self.setState({
            msg:
              error?.response?.data?.message ||
              "Update failed. Please try again.",
            toastColor: "danger",
            loading: false,
          });
        });
    } else if (s.userType === "TRADERS_CHANNEL_PARTNER") {
      let request = new FormData();
      request.append("user.userType", "COMPANY");
      request.append(
        "user.fullName",
        [s.tradersPrimaryContactFirstname, s.tradersPrimaryContactSurname].join(
          " "
        )
      );
      request.append("user.activeStatus", "YES");
      request.append("profile.companyName", s.tradersName);
      request.append("profile.tradingName", s.tradersTradingName || "");
      request.append("profile.registrationNumber", s.tradersRegistrationNumber);
      request.append("profile.townCityId", String(s.tradersTownCityId));
      request.append("profile.physicalAddress", s.tradersPhysicalAddress);
      request.append(
        "profile.primaryContactFirstName",
        s.tradersPrimaryContactFirstname
      );
      request.append(
        "profile.primaryContactSurname",
        s.tradersPrimaryContactSurname
      );
      request.append("profile.primaryContactRole", s.tradersPrimaryContactRole);
      request.append(
        "profile.primaryContactIdNumber",
        s.tradersPrimaryContactIdentification || ""
      );
      request.append(
        "profile.primaryPassportNumber",
        s.tradersPrimaryContactPassportNumber || ""
      );
      request.append(
        "profile.primaryContactNumber",
        s.tradersPrimaryContactCellphone
      );
      request.append(
        "profile.primaryContactEmail",
        s.tradersPrimaryContactEmail
      );
      request.append(
        "profile.billingContactFirstName",
        s.tradersBillingContactFirstname
      );
      request.append(
        "profile.billingContactSurname",
        s.tradersBillingContactSurname
      );
      request.append("profile.billingContactRole", s.tradersBillingContactRole);
      request.append(
        "profile.billingContactIdNumber",
        s.tradersBillingContactIdentification || ""
      );
      request.append(
        "profile.billingContactPassportNumber",
        s.tradersBillingContactPassportNumber || ""
      );
      request.append(
        "profile.billingContactEmail",
        s.tradersBillingContactEmail
      );
      request.append(
        "profile.billingContactNumber",
        s.tradersBillingContactCellphone
      );
      request.append("profile.companyType", "CORPORATE");
      if (s.tradersPrimaryContactIdentificationDocument) {
        request.append(
          "primaryContactIdentityDocument",
          s.tradersPrimaryContactIdentificationDocument
        );
      }
      if (s.tradersPrimaryContactPassportDocument) {
        request.append(
          "primaryContactPassportDocument",
          s.tradersPrimaryContactPassportDocument
        );
      }
      if (s.tradersBillingContactIdentificationDocument) {
        request.append(
          "billingContactIdentificationDocument",
          s.tradersBillingContactIdentificationDocument
        );
      }
      if (s.tradersBillingContactPassportDocument) {
        request.append(
          "billingContactPassportDocument",
          s.tradersBillingContactPassportDocument
        );
      }
      if (s.tradersCertificateOfIncorporation) {
        request.append(
          "certificateIncorpFile",
          s.tradersCertificateOfIncorporation
        );
      }
      if (s.tradersCr14) {
        request.append("cr14File", s.tradersCr14);
      }

      // Add document uploads
      const { documents } = s;
      if (documents.corporatePrimaryContactNationalId) {
        request.append("primaryContactIdentityDocument", documents.corporatePrimaryContactNationalId);
      }
      if (documents.corporatePrimaryContactPassport) {
        request.append("primaryContactPassportDocument", documents.corporatePrimaryContactPassport);
      }
      if (documents.corporateBillingContactNationalId) {
        request.append("billingContactIdentificationDocument", documents.corporateBillingContactNationalId);
      }
      if (documents.corporateBillingContactPassport) {
        request.append("billingContactPassportDocument", documents.corporateBillingContactPassport);
      }
      if (documents.corporateCR14) {
        request.append("cr14File", documents.corporateCR14);
      }
      if (documents.corporateCertificateOfIncorporation) {
        request.append("certificateIncorpFile", documents.corporateCertificateOfIncorporation);
      }
      axios
        .put(API + "/traders-channel-partner/update", request, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          if (response.data.success) {
            self.setState({
              msg: "Profile updated successfully!",
              toastColor: "success",
              loading: false,
            });
            setTimeout(() => {
              window.history.back();
            }, 1500);
          } else {
            self.setState({
              msg: response.data.message || "Update failed",
              toastColor: "danger",
              loading: false,
            });
          }
        })
        .catch((error) => {
          if (Number(error.status) === 403) {
            sessionStorage.clear();
            window.href = `/?redirectUrl=${window.location.pathname + window.location.search
              }`;
          }
          self.setState({
            msg:
              error?.response?.data?.message ||
              "Update failed. Please try again.",
            toastColor: "danger",
            loading: false,
          });
        });
    }
  }

  render() {
    const s = this.state;
    let divMsg = null;
    if (s.msg) {
      divMsg = (
        <div
          className={
            s.toastColor === "success"
              ? "alert alert-success mx-7"
              : "alert alert-danger mx-7"
          }
        >
          {s.msg}
        </div>
      );
    }
    if (s.loading) {
      return <Spinner className="" />;
    }

    const lookup = s.lookupData;
    return (
      <div className="min-vh-100 d-flex justify-content-between bg-white">
        <div className="min-vh-100 w-100 d-flex flex-column">
          {divMsg}
          <form
            className="d-flex flex-column align-items-center w-100 mt-2 overflow-auto was-validated"
            autoComplete="off"
            onSubmit={this.handleUpdate}
          >
            <div className="w-100" style={{ maxWidth: 62 + 'rem' }}>
              {s.userType === "INDIVIDUAL" ? (
                // Individual Form - copied and adapted from registration/individual.js
                <div className="grid grid-cols-2 gap-x-8 gap-y-4">
                  <div className="input-group">
                    <label className="input-group-text">Firstname</label>
                    <input
                      name="firstName"
                      className={`form-control ${s.errors.firstName ? " !border-red-500" : ""
                        }`}
                      value={s.firstName}
                      onChange={this.handleChange}
                      required
                      autoFocus
                    />
                    {s.errors.firstName && (
                      <span className="input-group-error">
                        {s.errors.firstName}
                      </span>
                    )}
                  </div>
                  <div className="input-group">
                    <label className="input-group-text">Middle Name</label>
                    <input
                      name="middleName"
                      className={`form-control ${s.errors.middleName ? " !border-red-500" : ""
                        }`}
                      value={s.middleName}
                      onChange={this.handleChange}
                    />
                    {s.errors.middleName && (
                      <span className="input-group-error">
                        {s.errors.middleName}
                      </span>
                    )}
                  </div>
                  <div className="input-group">
                    <label className="input-group-text">Surname</label>
                    <input
                      name="surname"
                      className={`form-control ${s.errors.surname ? " !border-red-500" : ""
                        }`}
                      value={s.surname}
                      onChange={this.handleChange}
                      required
                    />
                    {s.errors.surname && (
                      <span className="input-group-error">
                        {s.errors.surname}
                      </span>
                    )}
                  </div>
                  <div className="input-group">
                    <label className="input-group-text">Nationality</label>
                    <Select
                      value={(lookup.countrys || []).find(
                        ({ value }) => value === s.nationality
                      )}
                      onChange={(e) => {
                        this.handleIndividualNationalId("");
                        this.setState({
                          nationalIdNumber: "",
                          passportNumber: "",
                        });
                        this.handleSelect("nationality", e ? e.value : "");
                      }}
                      className={`form-control ${s.errors.nationality ? " !border-red-500" : ""
                        }`}
                      required
                      options={lookup.countrys || []}
                    />
                    {s.errors.nationality && (
                      <span className="input-group-error">
                        {s.errors.nationality}
                      </span>
                    )}
                  </div>
                  {s.nationality && this.isZimbabweanIndividual() ? (
                    <div className="input-group">
                      <label className="input-group-text">National ID</label>
                      <input
                        name="nationalIdNumber"
                        className={`form-control ${s.errors.nationalIdNumber ? " !border-red-500" : ""
                          }`}
                        value={s.nationalIdNumber}
                        placeholder={s.idPlaceholderIndividual}
                        onChange={(e) =>
                          this.handleIndividualNationalId(e.target.value)
                        }
                        required
                      />
                      {s.errors.nationalIdNumber && (
                        <span className="input-group-error">
                          {s.errors.nationalIdNumber}
                        </span>
                      )}
                    </div>
                  ) : s.nationality ? (
                    <div className="input-group">
                      <label className="input-group-text">
                        Passport Number
                      </label>
                      <input
                        name="passportNumber"
                        className={`form-control ${s.errors.passportNumber ? " !border-red-500" : ""
                          }`}
                        value={s.passportNumber}
                        onChange={this.handleChange}
                        required
                      />
                      {s.errors.passportNumber && (
                        <span className="input-group-error">
                          {s.errors.passportNumber}
                        </span>
                      )}
                    </div>
                  ) : null}
                  <div className="input-group">
                    <label className="input-group-text">Gender</label>
                    <select
                      name="gender"
                      className={`form-control ${s.errors.gender ? " !border-red-500" : ""
                        }`}
                      value={s.gender}
                      onChange={this.handleChange}
                      required
                    >
                      <option value="">Select</option>
                      {s.lookupData.genders.map((g) => (
                        <option key={g} value={g}>
                          {g}
                        </option>
                      ))}
                    </select>
                    {s.errors.gender && (
                      <span className="input-group-error">
                        {s.errors.gender}
                      </span>
                    )}
                  </div>
                  <div className="input-group">
                    <label className="input-group-text">Cellphone</label>
                    <input
                      name="cellPhone"
                      className={`form-control ${s.errors.cellPhone ? " !border-red-500" : ""
                        }`}
                      value={s.cellPhone}
                      onChange={this.handleChange}
                      required
                    />
                    {s.errors.cellPhone && (
                      <span className="input-group-error">
                        {s.errors.cellPhone}
                      </span>
                    )}
                  </div>
                  <div className="col-span-2 input-group">
                    <label className="input-group-text">Email</label>
                    <input
                      name="email"
                      type="email"
                      className={`form-control ${s.errors.email ? " !border-red-500" : ""
                        }`}
                      value={s.email}
                      onChange={this.handleChange}
                    />
                    {s.errors.email && (
                      <span className="input-group-error">
                        {s.errors.email}
                      </span>
                    )}
                  </div>
                  <div className="col-span-2 input-group">
                    <label className="input-group-text">
                      House No & Street
                    </label>
                    <input
                      name="houseNumberStreet"
                      className={`form-control ${s.errors.houseNumberStreet ? " !border-red-500" : ""
                        }`}
                      value={s.houseNumberStreet}
                      onChange={this.handleChange}
                      required
                    />
                    {s.errors.houseNumberStreet && (
                      <span className="input-group-error">
                        {s.errors.houseNumberStreet}
                      </span>
                    )}
                  </div>
                  <div className="input-group">
                    <label className="input-group-text">Suburb</label>
                    <input
                      name="suburb"
                      className={`form-control ${s.errors.suburb ? " !border-red-500" : ""
                        }`}
                      value={s.suburb}
                      onChange={this.handleChange}
                      required
                    />
                    {s.errors.suburb && (
                      <span className="input-group-error">
                        {s.errors.suburb}
                      </span>
                    )}
                  </div>
                  <div className="input-group">
                    <label className="input-group-text">Town/City</label>
                    <Select
                      value={(lookup.townCitys || []).find(
                        ({ value }) => value === s.townCityId
                      )}
                      onChange={(e) =>
                        this.handleSelect("townCityId", e ? e.value : 0)
                      }
                      className={`form-control ${s.errors.townCityId ? " !border-red-500" : ""
                        }`}
                      required
                      options={lookup.townCitys || []}
                    />
                    {s.errors.townCityId && (
                      <span className="input-group-error">
                        {s.errors.townCityId}
                      </span>
                    )}
                  </div>
                  {s.isPaidService === "YES" && (
                    <div className="input-group">
                      <label className="input-group-text">
                        Mobile Money Number
                      </label>
                      <input
                        name="mobileMoneyNumber"
                        className={`form-control ${s.errors.mobileMoneyNumber ? " !border-red-500" : ""
                          }`}
                        value={s.mobileMoneyNumber}
                        onChange={this.handleChange}
                        required
                      />
                      {s.errors.mobileMoneyNumber && (
                        <span className="input-group-error">
                          {s.errors.mobileMoneyNumber}
                        </span>
                      )}
                    </div>
                  )}
                </div>
              ) : s.userType === "INSURANCE" ? (
                // Insurance Form - adapted from registration/insurance.js
                <div className="grid grid-cols-2 gap-x-8 gap-y-4">
                  <div className="input-group">
                    <label className="input-group-text">Name</label>
                    <input
                      name="insuranceName"
                      className={`form-control ${s.errors.insuranceName ? " !border-red-500" : ""
                        }`}
                      value={s.insuranceName}
                      onChange={this.handleChange}
                      required
                      autoFocus
                    />
                    {s.errors.insuranceName && (
                      <span className="input-group-error">
                        {s.errors.insuranceName}
                      </span>
                    )}
                  </div>
                  <div className="input-group">
                    <label className="input-group-text">Registration No</label>
                    <input
                      name="insuranceRegistrationNumber"
                      className={`form-control ${s.errors.insuranceRegistrationNumber
                        ? " !border-red-500"
                        : ""
                        }`}
                      value={s.insuranceRegistrationNumber}
                      onChange={this.handleChange}
                      required
                    />
                    {s.errors.insuranceRegistrationNumber && (
                      <span className="input-group-error">
                        {s.errors.insuranceRegistrationNumber}
                      </span>
                    )}
                  </div>
                  <div className="input-group">
                    <label className="input-group-text">Address 1</label>
                    <input
                      name="insuranceAddress1"
                      className={`form-control ${s.errors.insuranceAddress1 ? " !border-red-500" : ""
                        }`}
                      value={s.insuranceAddress1}
                      onChange={this.handleChange}
                      required
                    />
                    {s.errors.insuranceAddress1 && (
                      <span className="input-group-error">
                        {s.errors.insuranceAddress1}
                      </span>
                    )}
                  </div>
                  <div className="input-group">
                    <label className="input-group-text">Address 2</label>
                    <input
                      name="insuranceAddress2"
                      className={`form-control ${s.errors.insuranceAddress2 ? " !border-red-500" : ""
                        }`}
                      value={s.insuranceAddress2}
                      onChange={this.handleChange}
                    />
                    {s.errors.insuranceAddress2 && (
                      <span className="input-group-error">
                        {s.errors.insuranceAddress2}
                      </span>
                    )}
                  </div>
                  <div className="input-group">
                    <label className="input-group-text required">
                      Town/City
                    </label>
                    <Select
                      name="insuranceTownCityId"
                      value={(lookup.townCitys || []).find(
                        ({ value }) => value === s.insuranceTownCityId
                      )}
                      onChange={(e) =>
                        this.handleSelect(
                          "insuranceTownCityId",
                          e ? e.value : 0
                        )
                      }
                      className={`form-control ${s.errors.insuranceTownCityId ? " !border-red-500" : ""
                        }`}
                      required
                      options={lookup.townCitys || []}
                    />
                    {s.errors.insuranceTownCityId && (
                      <span className="input-group-error">
                        {s.errors.insuranceTownCityId}
                      </span>
                    )}
                  </div>
                  <div></div>
                  <div className="input-group">
                    <label className="input-group-text">
                      Contact Firstname
                    </label>
                    <input
                      name="insuranceContactFirstname"
                      className={`form-control ${s.errors.insuranceContactFirstname
                        ? " !border-red-500"
                        : ""
                        }`}
                      value={s.insuranceContactFirstname}
                      onChange={this.handleChange}
                      required
                    />
                    {s.errors.insuranceContactFirstname && (
                      <span className="input-group-error">
                        {s.errors.insuranceContactFirstname}
                      </span>
                    )}
                  </div>
                  <div className="input-group">
                    <label className="input-group-text">Contact Surname</label>
                    <input
                      name="insuranceContactSurname"
                      className={`form-control ${s.errors.insuranceContactSurname
                        ? " !border-red-500"
                        : ""
                        }`}
                      value={s.insuranceContactSurname}
                      onChange={this.handleChange}
                      required
                    />
                    {s.errors.insuranceContactSurname && (
                      <span className="input-group-error">
                        {s.errors.insuranceContactSurname}
                      </span>
                    )}
                  </div>
                  <div className="input-group">
                    <label className="input-group-text">Contact Role</label>
                    <input
                      name="insuranceContactRole"
                      className={`form-control ${s.errors.insuranceContactRole ? " !border-red-500" : ""
                        }`}
                      value={s.insuranceContactRole}
                      onChange={this.handleChange}
                      required
                    />
                    {s.errors.insuranceContactRole && (
                      <span className="input-group-error">
                        {s.errors.insuranceContactRole}
                      </span>
                    )}
                  </div>
                  <div className="input-group">
                    <label className="input-group-text">Contact Email</label>
                    <input
                      name="insuranceContactEmail"
                      className={`form-control ${s.errors.insuranceContactEmail ? " !border-red-500" : ""
                        }`}
                      value={s.insuranceContactEmail}
                      onChange={this.handleChange}
                      required
                    />
                    {s.errors.insuranceContactEmail && (
                      <span className="input-group-error">
                        {s.errors.insuranceContactEmail}
                      </span>
                    )}
                  </div>
                  <div className="input-group">
                    <label className="input-group-text">
                      Contact Cellphone
                    </label>
                    <input
                      name="insuranceContactCellphone"
                      className={`form-control ${s.errors.insuranceContactCellphone
                        ? " !border-red-500"
                        : ""
                        }`}
                      value={s.insuranceContactCellphone}
                      onChange={this.handleChange}
                      required
                    />
                    {s.errors.insuranceContactCellphone && (
                      <span className="input-group-error">
                        {s.errors.insuranceContactCellphone}
                      </span>
                    )}
                  </div>
                  <div className="input-group">
                    <label className="input-group-text">
                      Contact Nationality
                    </label>
                    <Select
                      name="insuranceContactNationality"
                      value={(lookup.countrys || []).find(
                        ({ value }) => value === s.insuranceContactNationality
                      )}
                      onChange={(e) => {
                        this.setState({
                          insuranceContactIdentification: "",
                          insuranceContactPassportNumber: "",
                        });
                        this.handleSelect(
                          "insuranceContactNationality",
                          e ? e.value : ""
                        );
                      }}
                      className={`form-control ${s.errors.insuranceContactNationality
                        ? " !border-red-500"
                        : ""
                        }`}
                      required
                      options={lookup.countrys || []}
                    />
                    {s.errors.insuranceContactNationality && (
                      <span className="input-group-error">
                        {s.errors.insuranceContactNationality}
                      </span>
                    )}
                  </div>
                  {s.insuranceContactNationality === "ZW" ? (
                    <div className="input-group">
                      <label className="input-group-text">
                        Contact National ID
                      </label>
                      <input
                        name="insuranceContactIdentification"
                        className={`form-control ${s.errors.insuranceContactIdentification
                          ? " !border-red-500"
                          : ""
                          }`}
                        value={s.insuranceContactIdentification}
                        onChange={(e) => this.handleChange(e)}
                        required
                      />
                      {s.errors.insuranceContactIdentification && (
                        <span className="input-group-error">
                          {s.errors.insuranceContactIdentification}
                        </span>
                      )}
                    </div>
                  ) : s.insuranceContactNationality ? (
                    <div className="input-group">
                      <label className="input-group-text">
                        Contact Passport Number
                      </label>
                      <input
                        name="insuranceContactPassportNumber"
                        className={`form-control ${s.errors.insuranceContactPassportNumber
                          ? " !border-red-500"
                          : ""
                          }`}
                        value={s.insuranceContactPassportNumber}
                        onChange={this.handleChange}
                        required
                      />
                      {s.errors.insuranceContactPassportNumber && (
                        <span className="input-group-error">
                          {s.errors.insuranceContactPassportNumber}
                        </span>
                      )}
                    </div>
                  ) : null}
                  {s.insuranceContactNationality && (
                    <div className="input-group">
                      <label className="input-group-text">
                        {s.insuranceContactNationality === "ZW"
                          ? "Contact National ID Document"
                          : "Contact Passport Document"}
                      </label>
                      <input
                        name={
                          s.insuranceContactNationality === "ZW"
                            ? "insuranceContactIdentificationDocument"
                            : "insuranceContactPassportDocument"
                        }
                        className="form-control"
                        type="file"
                        onChange={this.handleChange}
                        accept=".pdf,image/*"
                      />
                    </div>
                  )}
                  <div className="input-group">
                    <label
                      htmlFor="insuranceCertOfIncorp"
                      className="input-group-text"
                    >
                      Certificate of Incorporation
                    </label>
                    <input
                      name="insuranceCertificateOfIncorporation"
                      className="form-control"
                      type="file"
                      id="insuranceCertOfIncorp"
                      onChange={this.handleChange}
                      accept=".pdf,image/*"
                    />
                  </div>
                  <div className="input-group">
                    <label htmlFor="insuranceCr14" className="input-group-text">
                      CR14
                    </label>
                    <input
                      name="insuranceCr14"
                      className="form-control"
                      type="file"
                      id="insuranceCr14"
                      onChange={this.handleChange}
                      accept=".pdf,image/*"
                    />
                  </div>
                </div>
              ) : s.userType === "LAW_ENFORCEMENT" ? (
                // Law Enforcement Form - adapted from registration/lawenforcement.js
                <div className="grid grid-cols-2 gap-x-8 gap-y-4">
                  <div className="input-group">
                    <label className="input-group-text">First Name</label>
                    <input
                      name="firstName"
                      className={`form-control ${s.errors.firstName ? " !border-red-500" : ""
                        }`}
                      value={s.firstName}
                      onChange={this.handleChange}
                      required
                      autoFocus
                    />
                    {s.errors.firstName && (
                      <span className="input-group-error">
                        {s.errors.firstName}
                      </span>
                    )}
                  </div>
                  <div className="input-group">
                    <label className="input-group-text">Middle Name</label>
                    <input
                      name="middleName"
                      className={`form-control ${s.errors.middleName ? " !border-red-500" : ""
                        }`}
                      value={s.middleName}
                      onChange={this.handleChange}
                    />
                    {s.errors.middleName && (
                      <span className="input-group-error">
                        {s.errors.middleName}
                      </span>
                    )}
                  </div>
                  <div className="input-group">
                    <label className="input-group-text">Surname</label>
                    <input
                      name="surname"
                      className={`form-control ${s.errors.surname ? " !border-red-500" : ""
                        }`}
                      value={s.surname}
                      onChange={this.handleChange}
                      required
                    />
                    {s.errors.surname && (
                      <span className="input-group-error">
                        {s.errors.surname}
                      </span>
                    )}
                  </div>
                  <div className="input-group">
                    <label className="input-group-text">Force Number</label>
                    <input
                      name="forceNumber"
                      className={`form-control ${s.errors.forceNumber ? " !border-red-500" : ""
                        }`}
                      value={s.forceNumber}
                      onChange={this.handleChange}
                      required
                    />
                    {s.errors.forceNumber && (
                      <span className="input-group-error">
                        {s.errors.forceNumber}
                      </span>
                    )}
                  </div>
                  <div className="input-group">
                    <label className="input-group-text required">Rank</label>
                    <Select
                      name="rankId"
                      options={(s.lawEnforcementLookupData?.ranks || []).map(
                        (r) => ({
                          value: r.id,
                          label: r.name,
                        })
                      )}
                      value={
                        (s.lawEnforcementLookupData?.ranks || []).find(
                          (r) => r.id === s.rankId
                        )
                          ? {
                            value: s.rankId,
                            label: (
                              s.lawEnforcementLookupData?.ranks || []
                            ).find((r) => r.id === s.rankId).name,
                          }
                          : null
                      }
                      onChange={(option) =>
                        this.handleSelect("rankId", option ? option.value : 0)
                      }
                      className={`form-control ${s.errors.rankId ? " !border-red-500" : ""
                        }`}
                      required
                    />
                    {s.errors.rankId && (
                      <span className="input-group-error">
                        {s.errors.rankId}
                      </span>
                    )}
                  </div>
                  <div className="input-group">
                    <label className="input-group-text required">Station</label>
                    <Select
                      name="stationId"
                      options={(s.lawEnforcementLookupData?.stations || []).map(
                        (r) => ({
                          value: r.id,
                          label: r.name,
                        })
                      )}
                      value={
                        (s.lawEnforcementLookupData?.stations || []).find(
                          (r) => r.id === s.stationId
                        )
                          ? {
                            value: s.stationId,
                            label: (
                              s.lawEnforcementLookupData?.stations || []
                            ).find((r) => r.id === s.stationId).name,
                          }
                          : null
                      }
                      onChange={(option) =>
                        this.handleSelect(
                          "stationId",
                          option ? option.value : 0
                        )
                      }
                      className={`form-control ${s.errors.stationId ? " !border-red-500" : ""
                        }`}
                      required
                    />
                    {s.errors.stationId && (
                      <span className="input-group-error">
                        {s.errors.stationId}
                      </span>
                    )}
                  </div>
                  <div className="input-group">
                    <label className="input-group-text required">Role</label>
                    <Select
                      name="roleId"
                      options={(s.lawEnforcementLookupData?.roles || []).map(
                        (r) => ({
                          value: r.id,
                          label: r.name,
                        })
                      )}
                      value={
                        (s.lawEnforcementLookupData?.roles || []).find(
                          (r) => r.id === s.roleId
                        )
                          ? {
                            value: s.roleId,
                            label: (
                              s.lawEnforcementLookupData?.roles || []
                            ).find((r) => r.id === s.roleId).name,
                          }
                          : null
                      }
                      onChange={(option) =>
                        this.handleSelect("roleId", option ? option.value : 0)
                      }
                      className={`form-control ${s.errors.roleId ? " !border-red-500" : ""
                        }`}
                      required
                    />
                    {s.errors.roleId && (
                      <span className="input-group-error">
                        {s.errors.roleId}
                      </span>
                    )}
                  </div>
                  <div className="input-group">
                    <label className="input-group-text">Nationality</label>
                    <Select
                      name="lawEnforcementNationality"
                      value={(lookup.countrys || []).find(
                        ({ value }) => value === s.lawEnforcementNationality
                      )}
                      onChange={(e) => {
                        this.setState({
                          lawEnforcementNationalIdNumber: "",
                          lawEnforcementPassportNumber: "",
                        });
                        this.handleSelect(
                          "lawEnforcementNationality",
                          e ? e.value : ""
                        );
                      }}
                      className={`form-control ${s.errors.lawEnforcementNationality
                        ? " !border-red-500"
                        : ""
                        }`}
                      required
                      options={lookup.countrys || []}
                    />
                    {s.errors.lawEnforcementNationality && (
                      <span className="input-group-error">
                        {s.errors.lawEnforcementNationality}
                      </span>
                    )}
                  </div>
                  {s.lawEnforcementNationality === "ZW" ? (
                    <div className="input-group">
                      <label className="input-group-text">National ID</label>
                      <input
                        name="lawEnforcementNationalIdNumber"
                        className={`form-control ${s.errors.lawEnforcementNationalIdNumber
                          ? " !border-red-500"
                          : ""
                          }`}
                        value={s.lawEnforcementNationalIdNumber}
                        onChange={this.handleChange}
                        required
                      />
                      {s.errors.lawEnforcementNationalIdNumber && (
                        <span className="input-group-error">
                          {s.errors.lawEnforcementNationalIdNumber}
                        </span>
                      )}
                    </div>
                  ) : s.lawEnforcementNationality ? (
                    <div className="input-group">
                      <label className="input-group-text">
                        Passport Number
                      </label>
                      <input
                        name="lawEnforcementPassportNumber"
                        className={`form-control ${s.errors.lawEnforcementPassportNumber
                          ? " !border-red-500"
                          : ""
                          }`}
                        value={s.lawEnforcementPassportNumber}
                        onChange={this.handleChange}
                        required
                      />
                      {s.errors.lawEnforcementPassportNumber && (
                        <span className="input-group-error">
                          {s.errors.lawEnforcementPassportNumber}
                        </span>
                      )}
                    </div>
                  ) : null}
                  <div className="input-group">
                    <label className="input-group-text">Gender</label>
                    <select
                      name="lawEnforcementGender"
                      className={`form-control ${s.errors.lawEnforcementGender ? " !border-red-500" : ""
                        }`}
                      value={s.lawEnforcementGender}
                      onChange={this.handleChange}
                      required
                    >
                      <option value="">Select</option>
                      <option value="Male">Male</option>
                      <option value="Female">Female</option>
                      <option value="Other">Other</option>
                    </select>
                    {s.errors.lawEnforcementGender && (
                      <span className="input-group-error">
                        {s.errors.lawEnforcementGender}
                      </span>
                    )}
                  </div>
                  <div className="input-group">
                    <label className="input-group-text">Cellphone</label>
                    <input
                      name="lawEnforcementCellPhone"
                      className={`form-control ${s.errors.lawEnforcementCellPhone
                        ? " !border-red-500"
                        : ""
                        }`}
                      value={s.lawEnforcementCellPhone}
                      onChange={this.handleChange}
                      required
                    />
                    {s.errors.lawEnforcementCellPhone && (
                      <span className="input-group-error">
                        {s.errors.lawEnforcementCellPhone}
                      </span>
                    )}
                  </div>
                </div>
              ) : s.userType === "TRADERS_CHANNEL_PARTNER" ? (
                // Traders Channel Partner Form - adapted from registration/traderschannelpartner.js
                <>
                  <div className="grid grid-cols-2 gap-x-8 gap-y-4">
                    <div className="input-group">
                      <label className="input-group-text">Name</label>
                      <input
                        name="tradersName"
                        className={`form-control ${s.errors.tradersName ? " !border-red-500" : ""
                          }`}
                        value={s.tradersName}
                        onChange={this.handleChange}
                        required
                        autoFocus
                      />
                      {s.errors.tradersName && (
                        <span className="input-group-error">
                          {s.errors.tradersName}
                        </span>
                      )}
                    </div>
                    <div className="input-group">
                      <label className="input-group-text">
                        Registration No
                      </label>
                      <input
                        name="tradersRegistrationNumber"
                        className={`form-control ${s.errors.tradersRegistrationNumber
                          ? " !border-red-500"
                          : ""
                          }`}
                        value={s.tradersRegistrationNumber}
                        onChange={this.handleChange}
                        required
                      />
                      {s.errors.tradersRegistrationNumber && (
                        <span className="input-group-error">
                          {s.errors.tradersRegistrationNumber}
                        </span>
                      )}
                    </div>
                    <div className="input-group">
                      <label className="input-group-text">Trading Name</label>
                      <input
                        name="tradersTradingName"
                        className={`form-control ${s.errors.tradersTradingName ? " !border-red-500" : ""
                          }`}
                        value={s.tradersTradingName}
                        onChange={this.handleChange}
                      />
                      {s.errors.tradersTradingName && (
                        <span className="input-group-error">
                          {s.errors.tradersTradingName}
                        </span>
                      )}
                    </div>
                    <div></div>
                  </div>
                  {/* Primary Contact Section */}
                  <div className="form-blue-card mt-3">
                    <div className="form-blue-card-grid space-y-3">
                      <div className="col-span-2 font-bold">
                        Primary Contact
                      </div>
                      <div className="input-group">
                        <label className="input-group-text">Firstname</label>
                        <input
                          name="tradersPrimaryContactFirstname"
                          className={`form-control ${s.errors.tradersPrimaryContactFirstname
                            ? " !border-red-500"
                            : ""
                            }`}
                          value={s.tradersPrimaryContactFirstname}
                          onChange={this.handleChange}
                          required
                        />
                        {s.errors.tradersPrimaryContactFirstname && (
                          <span className="input-group-error">
                            {s.errors.tradersPrimaryContactFirstname}
                          </span>
                        )}
                      </div>
                      <div className="input-group">
                        <label className="input-group-text">Surname</label>
                        <input
                          name="tradersPrimaryContactSurname"
                          className={`form-control ${s.errors.tradersPrimaryContactSurname
                            ? " !border-red-500"
                            : ""
                            }`}
                          value={s.tradersPrimaryContactSurname}
                          onChange={this.handleChange}
                          required
                        />
                        {s.errors.tradersPrimaryContactSurname && (
                          <span className="input-group-error">
                            {s.errors.tradersPrimaryContactSurname}
                          </span>
                        )}
                      </div>
                      <div className="input-group">
                        <label className="input-group-text">Role</label>
                        <input
                          name="tradersPrimaryContactRole"
                          className={`form-control ${s.errors.tradersPrimaryContactRole
                            ? " !border-red-500"
                            : ""
                            }`}
                          value={s.tradersPrimaryContactRole}
                          onChange={this.handleChange}
                          required
                        />
                        {s.errors.tradersPrimaryContactRole && (
                          <span className="input-group-error">
                            {s.errors.tradersPrimaryContactRole}
                          </span>
                        )}
                      </div>
                      <div className="input-group">
                        <label className="input-group-text">Email</label>
                        <input
                          name="tradersPrimaryContactEmail"
                          type="email"
                          className={`form-control ${s.errors.tradersPrimaryContactEmail
                            ? " !border-red-500"
                            : ""
                            }`}
                          value={s.tradersPrimaryContactEmail}
                          onChange={this.handleChange}
                          required
                        />
                        {s.errors.tradersPrimaryContactEmail && (
                          <span className="input-group-error">
                            {s.errors.tradersPrimaryContactEmail}
                          </span>
                        )}
                      </div>
                      <div className="input-group">
                        <label className="input-group-text">Cellphone</label>
                        <input
                          name="tradersPrimaryContactCellphone"
                          className={`form-control ${s.errors.tradersPrimaryContactCellphone
                            ? " !border-red-500"
                            : ""
                            }`}
                          value={s.tradersPrimaryContactCellphone}
                          onChange={this.handleChange}
                          required
                        />
                        {s.errors.tradersPrimaryContactCellphone && (
                          <span className="input-group-error">
                            {s.errors.tradersPrimaryContactCellphone}
                          </span>
                        )}
                      </div>
                      <div className="input-group">
                        <label className="input-group-text">Nationality</label>
                        <Select
                          value={(lookup.countrys || []).find(
                            ({ value }) =>
                              value === s.tradersPrimaryContactNationality
                          )}
                          onChange={(e) => {
                            this.setState({
                              tradersPrimaryContactIdentification: "",
                              tradersPrimaryContactPassportNumber: "",
                            });
                            this.handleSelect(
                              "tradersPrimaryContactNationality",
                              e ? e.value : ""
                            );
                          }}
                          className={`form-control ${s.errors.tradersPrimaryContactNationality
                            ? " !border-red-500"
                            : ""
                            }`}
                          required
                          options={lookup.countrys || []}
                        />
                        {s.errors.tradersPrimaryContactNationality && (
                          <span className="input-group-error">
                            {s.errors.tradersPrimaryContactNationality}
                          </span>
                        )}
                      </div>
                      {s.tradersPrimaryContactNationality === "ZW" ? (
                        <>
                          <div className="input-group">
                            <label className="input-group-text">
                              National ID
                            </label>
                            <input
                              name="tradersPrimaryContactIdentification"
                              className={`form-control ${s.errors.tradersPrimaryContactIdentification
                                ? " !border-red-500"
                                : ""
                                }`}
                              value={s.tradersPrimaryContactIdentification}
                              onChange={this.handleChange}
                              required
                            />
                            {s.errors.tradersPrimaryContactIdentification && (
                              <span className="input-group-error">
                                {s.errors.tradersPrimaryContactIdentification}
                              </span>
                            )}
                          </div>
                          <div className="input-group">
                            <label className="input-group-text">
                              National ID Document
                            </label>
                            <input
                              name="tradersPrimaryContactIdentificationDocument"
                              type="file"
                              className="form-control"
                              onChange={this.handleChange}
                              accept=".pdf,image/*"
                            />
                          </div>
                        </>
                      ) : s.tradersPrimaryContactNationality ? (
                        <>
                          <div className="input-group">
                            <label className="input-group-text">
                              Passport Number
                            </label>
                            <input
                              name="tradersPrimaryContactPassportNumber"
                              className={`form-control ${s.errors.tradersPrimaryContactPassportNumber
                                ? " !border-red-500"
                                : ""
                                }`}
                              value={s.tradersPrimaryContactPassportNumber}
                              onChange={this.handleChange}
                              required
                            />
                            {s.errors.tradersPrimaryContactPassportNumber && (
                              <span className="input-group-error">
                                {s.errors.tradersPrimaryContactPassportNumber}
                              </span>
                            )}
                          </div>
                          <div className="input-group">
                            <label className="input-group-text">
                              Passport Document
                            </label>
                            <input
                              name="tradersPrimaryContactPassportDocument"
                              type="file"
                              className="form-control"
                              onChange={this.handleChange}
                              accept=".pdf,image/*"
                            />
                          </div>
                        </>
                      ) : null}
                    </div>
                  </div>
                  {/* Billing Contact Section */}
                  <div className="form-blue-card mt-3">
                    <div className="form-blue-card-grid space-y-3">
                      <div className="col-span-2 font-bold">
                        Billing Contact
                      </div>
                      <div className="input-group">
                        <label className="input-group-text">Firstname</label>
                        <input
                          name="tradersBillingContactFirstname"
                          className={`form-control ${s.errors.tradersBillingContactFirstname
                            ? " !border-red-500"
                            : ""
                            }`}
                          value={s.tradersBillingContactFirstname}
                          onChange={this.handleChange}
                          required
                        />
                        {s.errors.tradersBillingContactFirstname && (
                          <span className="input-group-error">
                            {s.errors.tradersBillingContactFirstname}
                          </span>
                        )}
                      </div>
                      <div className="input-group">
                        <label className="input-group-text">Surname</label>
                        <input
                          name="tradersBillingContactSurname"
                          className={`form-control ${s.errors.tradersBillingContactSurname
                            ? " !border-red-500"
                            : ""
                            }`}
                          value={s.tradersBillingContactSurname}
                          onChange={this.handleChange}
                          required
                        />
                        {s.errors.tradersBillingContactSurname && (
                          <span className="input-group-error">
                            {s.errors.tradersBillingContactSurname}
                          </span>
                        )}
                      </div>
                      <div className="input-group">
                        <label className="input-group-text">Role</label>
                        <input
                          name="tradersBillingContactRole"
                          className={`form-control ${s.errors.tradersBillingContactRole
                            ? " !border-red-500"
                            : ""
                            }`}
                          value={s.tradersBillingContactRole}
                          onChange={this.handleChange}
                          required
                        />
                        {s.errors.tradersBillingContactRole && (
                          <span className="input-group-error">
                            {s.errors.tradersBillingContactRole}
                          </span>
                        )}
                      </div>
                      <div className="input-group">
                        <label className="input-group-text">Email</label>
                        <input
                          name="tradersBillingContactEmail"
                          className={`form-control ${s.errors.tradersBillingContactEmail
                            ? " !border-red-500"
                            : ""
                            }`}
                          type="email"
                          value={s.tradersBillingContactEmail}
                          onChange={this.handleChange}
                          required
                        />
                        {s.errors.tradersBillingContactEmail && (
                          <span className="input-group-error">
                            {s.errors.tradersBillingContactEmail}
                          </span>
                        )}
                      </div>
                      <div className="input-group">
                        <label className="input-group-text">Cellphone</label>
                        <input
                          name="tradersBillingContactCellphone"
                          className={`form-control ${s.errors.tradersBillingContactCellphone
                            ? " !border-red-500"
                            : ""
                            }`}
                          value={s.tradersBillingContactCellphone}
                          onChange={this.handleChange}
                          required
                        />
                        {s.errors.tradersBillingContactCellphone && (
                          <span className="input-group-error">
                            {s.errors.tradersBillingContactCellphone}
                          </span>
                        )}
                      </div>
                      <div className="input-group">
                        <label className="input-group-text">Nationality</label>
                        <Select
                          name="tradersBillingContactNationality"
                          value={(lookup.countrys || []).find(
                            ({ value }) =>
                              value === s.tradersBillingContactNationality
                          )}
                          onChange={(e) => {
                            this.setState({
                              tradersBillingContactIdentification: "",
                              tradersBillingContactPassportNumber: "",
                            });
                            this.handleSelect(
                              "tradersBillingContactNationality",
                              e ? e.value : ""
                            );
                          }}
                          className={`form-control ${s.errors.tradersBillingContactNationality
                            ? " !border-red-500"
                            : ""
                            }`}
                          required
                          options={lookup.countrys || []}
                        />
                        {s.errors.tradersBillingContactNationality && (
                          <span className="input-group-error">
                            {s.errors.tradersBillingContactNationality}
                          </span>
                        )}
                      </div>
                      {s.tradersBillingContactNationality === "ZW" ? (
                        <div className="input-group">
                          <label className="input-group-text">
                            National ID
                          </label>
                          <input
                            name="tradersBillingContactIdentification"
                            className={`form-control ${s.errors.tradersBillingContactIdentification
                              ? " !border-red-500"
                              : ""
                              }`}
                            value={s.tradersBillingContactIdentification}
                            onChange={this.handleChange}
                            required
                          />
                          {s.errors.tradersBillingContactIdentification && (
                            <span className="input-group-error">
                              {s.errors.tradersBillingContactIdentification}
                            </span>
                          )}
                        </div>
                      ) : s.tradersBillingContactNationality ? (
                        <div className="input-group">
                          <label className="input-group-text">
                            Passport Number
                          </label>
                          <input
                            name="tradersBillingContactPassportNumber"
                            className={`form-control ${s.errors.tradersBillingContactPassportNumber
                              ? " !border-red-500"
                              : ""
                              }`}
                            value={s.tradersBillingContactPassportNumber}
                            onChange={this.handleChange}
                            required
                          />
                          {s.errors.tradersBillingContactPassportNumber && (
                            <span className="input-group-error">
                              {s.errors.tradersBillingContactPassportNumber}
                            </span>
                          )}
                        </div>
                      ) : null}
                    </div>
                  </div>
                  <div className="grid grid-cols-2 gap-x-8 gap-y-4 mt-3">
                    <div className="col-span-2 input-group">
                      <label className="input-group-text">
                        Physical Address
                      </label>
                      <input
                        name="tradersPhysicalAddress"
                        className={`form-control ${s.errors.tradersPhysicalAddress
                          ? " !border-red-500"
                          : ""
                          }`}
                        value={s.tradersPhysicalAddress}
                        onChange={this.handleChange}
                        required
                      />
                      {s.errors.tradersPhysicalAddress && (
                        <span className="input-group-error">
                          {s.errors.tradersPhysicalAddress}
                        </span>
                      )}
                    </div>
                    <div className="input-group">
                      <label className="input-group-text">Country</label>
                      <Select
                        value={(lookup.countrys || []).find(
                          ({ value }) => value === s.tradersCountry
                        )}
                        onChange={(e) =>
                          this.handleSelect("tradersCountry", e ? e.value : "")
                        }
                        className={`form-control ${s.errors.tradersCountry ? " !border-red-500" : ""
                          }`}
                        required
                        options={lookup.countrys || []}
                      />
                      {s.errors.tradersCountry && (
                        <span className="input-group-error">
                          {s.errors.tradersCountry}
                        </span>
                      )}
                    </div>
                    <div className="input-group">
                      <label className="input-group-text">Town/City</label>
                      <Select
                        name="tradersTownCityId"
                        value={(lookup.townCitys || []).find(
                          ({ value }) => value === s.tradersTownCityId
                        )}
                        onChange={(e) =>
                          this.handleSelect(
                            "tradersTownCityId",
                            e ? e.value : 0
                          )
                        }
                        className={`form-control ${s.errors.tradersTownCityId ? " !border-red-500" : ""
                          }`}
                        required
                        options={lookup.townCitys || []}
                      />
                      {s.errors.tradersTownCityId && (
                        <span className="input-group-error">
                          {s.errors.tradersTownCityId}
                        </span>
                      )}
                    </div>
                    <div className="input-group">
                      <label
                        htmlFor="tradersCertOfIncorp"
                        className="input-group-text"
                      >
                        Certificate of Incorporation
                      </label>
                      <input
                        name="tradersCertificateOfIncorporation"
                        className="form-control"
                        type="file"
                        id="tradersCertOfIncorp"
                        onChange={this.handleChange}
                        accept=".pdf,image/*"
                      />
                    </div>
                    <div className="input-group">
                      <label htmlFor="tradersCr14" className="input-group-text">
                        CR14
                      </label>
                      <input
                        name="tradersCr14"
                        className="form-control"
                        type="file"
                        id="tradersCr14"
                        onChange={this.handleChange}
                        accept=".pdf,image/*"
                      />
                    </div>
                  </div>
                </>
              ) : (
                <>
                  <div className="grid grid-cols-2 gap-x-8 gap-y-4">
                    <div className="input-group">
                      <label className="input-group-text">Name</label>
                      <input
                        name="companyName"
                        className={`form-control ${s.errors.companyName ? " !border-red-500" : ""
                          }`}
                        value={s.companyName}
                        onChange={this.handleChange}
                        required
                        autoFocus
                      />
                      {s.errors.companyName && (
                        <span className="input-group-error">
                          {s.errors.companyName}
                        </span>
                      )}
                    </div>
                    <div className="input-group">
                      <label className="input-group-text">
                        Registration No
                      </label>
                      <input
                        name="registrationNumber"
                        className={`form-control ${s.errors.registrationNumber ? " !border-red-500" : ""
                          }`}
                        value={s.registrationNumber}
                        onChange={this.handleChange}
                        required
                      />
                      {s.errors.registrationNumber && (
                        <span className="input-group-error">
                          {s.errors.registrationNumber}
                        </span>
                      )}
                    </div>
                    <div className="input-group">
                      <label className="input-group-text">Trading Name</label>
                      <input
                        name="tradingName"
                        className={`form-control ${s.errors.tradingName ? " !border-red-500" : ""
                          }`}
                        value={s.tradingName}
                        onChange={this.handleChange}
                      />
                      {s.errors.tradingName && (
                        <span className="input-group-error">
                          {s.errors.tradingName}
                        </span>
                      )}
                    </div>
                    <div></div>
                  </div>
                  {/* Primary Contact Section */}
                  <div className="form-blue-card mt-3">
                    <div className="form-blue-card-grid space-y-3">
                      <div className="col-span-2 font-bold">
                        Primary Contact
                      </div>
                      <div className="input-group">
                        <label className="input-group-text">Firstname</label>
                        <input
                          name="primaryContactFirstName"
                          className={`form-control ${s.errors.primaryContactFirstName
                            ? " !border-red-500"
                            : ""
                            }`}
                          value={s.primaryContactFirstName}
                          onChange={this.handleChange}
                          required
                        />
                        {s.errors.primaryContactFirstName && (
                          <span className="input-group-error">
                            {s.errors.primaryContactFirstName}
                          </span>
                        )}
                      </div>
                      <div className="input-group">
                        <label className="input-group-text">Surname</label>
                        <input
                          name="primaryContactSurname"
                          className={`form-control ${s.errors.primaryContactSurname
                            ? " !border-red-500"
                            : ""
                            }`}
                          value={s.primaryContactSurname}
                          onChange={this.handleChange}
                          required
                        />
                        {s.errors.primaryContactSurname && (
                          <span className="input-group-error">
                            {s.errors.primaryContactSurname}
                          </span>
                        )}
                      </div>
                      <div className="input-group">
                        <label className="input-group-text">Role</label>
                        <input
                          name="primaryContactRole"
                          className={`form-control ${s.errors.primaryContactRole
                            ? " !border-red-500"
                            : ""
                            }`}
                          value={s.primaryContactRole}
                          onChange={this.handleChange}
                          required
                        />
                        {s.errors.primaryContactRole && (
                          <span className="input-group-error">
                            {s.errors.primaryContactRole}
                          </span>
                        )}
                      </div>
                      <div className="input-group">
                        <label className="input-group-text">Email</label>
                        <input
                          name="primaryContactEmail"
                          type="email"
                          className={`form-control ${s.errors.primaryContactEmail
                            ? " !border-red-500"
                            : ""
                            }`}
                          value={s.primaryContactEmail}
                          onChange={this.handleChange}
                          required
                        />
                        {s.errors.primaryContactEmail && (
                          <span className="input-group-error">
                            {s.errors.primaryContactEmail}
                          </span>
                        )}
                      </div>
                      <div className="input-group">
                        <label className="input-group-text">Cellphone</label>
                        <input
                          name="primaryContactNumber"
                          className={`form-control ${s.errors.primaryContactNumber
                            ? " !border-red-500"
                            : ""
                            }`}
                          value={s.primaryContactNumber}
                          onChange={this.handleChange}
                          required
                        />
                        {s.errors.primaryContactNumber && (
                          <span className="input-group-error">
                            {s.errors.primaryContactNumber}
                          </span>
                        )}
                      </div>
                      <div className="input-group">
                        <label className="input-group-text">Nationality</label>
                        <Select
                          value={(lookup.countrys || []).find(
                            ({ value }) => value === s.primaryContactNationality
                          )}
                          onChange={(e) => {
                            this.handlePrimaryNationalId("");
                            this.setState({
                              primaryContactIdNumber: "",
                              primaryContactPassportNumber: "",
                            });
                            this.handleSelect(
                              "primaryContactNationality",
                              e ? e.value : ""
                            );
                          }}
                          className={`form-control ${s.errors.primaryContactNationality
                            ? " !border-red-500"
                            : ""
                            }`}
                          required
                          options={lookup.countrys || []}
                        />
                        {s.errors.primaryContactNationality && (
                          <span className="input-group-error">
                            {s.errors.primaryContactNationality}
                          </span>
                        )}
                      </div>
                      {s.primaryContactNationality &&
                        this.isZimbabweanPrimary() ? (
                        <>
                          <div className="input-group">
                            <label className="input-group-text">
                              National ID
                            </label>
                            <input
                              name="primaryContactIdNumber"
                              className={`form-control ${s.errors.primaryContactIdNumber
                                ? " !border-red-500"
                                : ""
                                }`}
                              value={s.primaryContactIdNumber}
                              placeholder={s.idPlaceholderPrimary}
                              onChange={(e) =>
                                this.handlePrimaryNationalId(e.target.value)
                              }
                              required
                            />
                            {s.errors.primaryContactIdNumber && (
                              <span className="input-group-error">
                                {s.errors.primaryContactIdNumber}
                              </span>
                            )}
                          </div>
                          <div className="input-group">
                            <label className="input-group-text">
                              National ID Document
                            </label>
                            <input
                              name="primaryContactIdentificationDocument"
                              type="file"
                              className="form-control"
                              onChange={this.handleChange}
                              accept=".pdf,image/*"
                            />
                          </div>
                        </>
                      ) : s.primaryContactNationality ? (
                        <>
                          <div className="input-group">
                            <label className="input-group-text">
                              Passport Number
                            </label>
                            <input
                              name="primaryContactPassportNumber"
                              className={`form-control ${s.errors.primaryContactPassportNumber
                                ? " !border-red-500"
                                : ""
                                }`}
                              value={s.primaryContactPassportNumber}
                              onChange={this.handleChange}
                              required
                            />
                            {s.errors.primaryContactPassportNumber && (
                              <span className="input-group-error">
                                {s.errors.primaryContactPassportNumber}
                              </span>
                            )}
                          </div>
                          <div className="input-group">
                            <label className="input-group-text">
                              Passport Document
                            </label>
                            <input
                              name="primaryContactPassportDocument"
                              type="file"
                              className="form-control"
                              onChange={this.handleChange}
                              accept=".pdf,image/*"
                            />
                          </div>
                        </>
                      ) : null}
                    </div>
                  </div>
                  {/* Billing Contact Section - similar structure */}
                  <div className="form-blue-card mt-3">
                    <div className="form-blue-card-grid space-y-3">
                      <div className="col-span-2 font-bold">
                        Billing Contact
                      </div>
                      <div className="input-group">
                        <label className="input-group-text">Firstname</label>
                        <input
                          name="billingContactFirstname"
                          className={`form-control ${s.errors.billingContactFirstname
                            ? " !border-red-500"
                            : ""
                            }`}
                          value={s?.billingContactFirstname}
                          onChange={this.handleChange}
                          required
                        />
                        {s.errors.billingContactFirstname && (
                          <span className="input-group-error">
                            {s.errors.billingContactFirstname}
                          </span>
                        )}
                      </div>
                      <div className="input-group">
                        <label className="input-group-text">Surname</label>
                        <input
                          name="billingContactSurname"
                          className={`form-control ${s.errors.billingContactSurname
                            ? " !border-red-500"
                            : ""
                            }`}
                          value={s?.billingContactSurname}
                          onChange={this.handleChange}
                          required
                        />
                        {s.errors.billingContactSurname && (
                          <span className="input-group-error">
                            {s.errors.billingContactSurname}
                          </span>
                        )}
                      </div>
                      <div className="input-group">
                        <label className="input-group-text">Role</label>
                        <input
                          name="billingContactRole"
                          className={`form-control ${s.errors.billingContactRole
                            ? " !border-red-500"
                            : ""
                            }`}
                          value={s?.billingContactRole}
                          onChange={this.handleChange}
                          required
                        />
                        {s.errors.billingContactRole && (
                          <span className="input-group-error">
                            {s.errors.billingContactRole}
                          </span>
                        )}
                      </div>
                      <div className="input-group">
                        <label className="input-group-text">Email</label>
                        <input
                          name="billingContactEmail"
                          className={`form-control ${s.errors.billingContactEmail
                            ? " !border-red-500"
                            : ""
                            }`}
                          type="email"
                          value={s?.billingContactEmail}
                          onChange={this.handleChange}
                          required
                        />
                        {s.errors.billingContactEmail && (
                          <span className="input-group-error">
                            {s.errors.billingContactEmail}
                          </span>
                        )}
                      </div>
                      <div className="input-group">
                        <label className="input-group-text">Cellphone</label>
                        <input
                          name="billingContactCellphone"
                          className={`form-control ${s.errors.billingContactCellphone
                            ? " !border-red-500"
                            : ""
                            }`}
                          value={s?.billingContactCellphone}
                          onChange={this.handleChange}
                          required
                        />
                        {s.errors.billingContactCellphone && (
                          <span className="input-group-error">
                            {s.errors.billingContactCellphone}
                          </span>
                        )}
                      </div>
                      <div className="input-group">
                        <label className="input-group-text">Nationality</label>
                        <Select
                          name="billingContactNationality"
                          value={(s.companyLookupData?.townCitys || []).find(
                            ({ value }) => value === s.billingContactNationality
                          )}
                          onChange={(e) => {
                            this.handleBillingNationalId("");
                            this.handleBillingNationalId(
                              "",
                              "billingContactPassportNumber"
                            );
                            this.setState({
                              idPlaceholderBilling: ogPlaceholder,
                            });
                            this.handleSelect(
                              "billingContactNationality",
                              e ? e.value : ""
                            );
                          }}
                          className={`form-control ${s.errors.billingContactNationality
                            ? " !border-red-500"
                            : ""
                            }`}
                          required
                          options={s.companyLookupData?.countrys || []}
                        />
                        {s.errors.billingContactNationality && (
                          <span className="input-group-error">
                            {s.errors.billingContactNationality}
                          </span>
                        )}
                      </div>
                      {!!s.billingContactNationality &&
                        this.isZimbabweanBilling() ? (
                        <div className="input-group">
                          <label className="input-group-text">
                            National ID
                          </label>
                          <input
                            name="billingContactIdentification"
                            className={`form-control ${s.errors.billingContactIdentification
                              ? " !border-red-500"
                              : ""
                              }`}
                            value={s?.billingContactIdentification}
                            placeholder={s.idPlaceholderBilling}
                            onChange={(e) =>
                              this.handleBillingNationalId(e.target.value)
                            }
                            required
                          />
                          {s.errors.billingContactIdentification && (
                            <span className="input-group-error">
                              {s.errors.billingContactIdentification}
                            </span>
                          )}
                        </div>
                      ) : !!s.billingContactNationality ? (
                        <div className="input-group">
                          <label className="input-group-text">
                            Passport Number
                          </label>
                          <input
                            name="billingContactPassportNumber"
                            className={`form-control ${s.errors.billingContactPassportNumber
                              ? " !border-red-500"
                              : ""
                              }`}
                            value={s?.billingContactPassportNumber}
                            onChange={(e) =>
                              this.handleBillingNationalId(
                                e.target.value,
                                "billingContactPassportNumber"
                              )
                            }
                            required
                          />
                          {s.errors.billingContactPassportNumber && (
                            <span className="input-group-error">
                              {s.errors.billingContactPassportNumber}
                            </span>
                          )}
                        </div>
                      ) : null}
                    </div>
                  </div>
                  <div className="grid grid-cols-2 gap-x-8 gap-y-4 mt-3">
                    <div className="col-span-2 input-group">
                      <label className="input-group-text">
                        Physical Address
                      </label>
                      <input
                        name="physicalAddress"
                        className={`form-control ${s.errors.physicalAddress ? " !border-red-500" : ""
                          }`}
                        value={s.physicalAddress}
                        onChange={this.handleChange}
                        required
                      />
                      {s.errors.physicalAddress && (
                        <span className="input-group-error">
                          {s.errors.physicalAddress}
                        </span>
                      )}
                    </div>
                    <div className="input-group">
                      <label className="input-group-text">Town/City</label>
                      <Select
                        value={(lookup.townCitys || []).find(
                          ({ value }) => value === s.townCityId
                        )}
                        onChange={(e) =>
                          this.handleSelect("townCityId", e ? e.value : 0)
                        }
                        className={`form-control ${s.errors.townCityId ? " !border-red-500" : ""
                          }`}
                        required
                        options={lookup.townCitys || []}
                      />
                      {s.errors.townCityId && (
                        <span className="input-group-error">
                          {s.errors.townCityId}
                        </span>
                      )}
                    </div>
                    <div className="input-group">
                      <label className="input-group-text">
                        Certificate of Incorporation
                      </label>
                      <input
                        name="certificateOfIncorporation"
                        type="file"
                        className="form-control"
                        onChange={this.handleChange}
                        accept=".pdf,image/*"
                      />
                    </div>
                    <div className="input-group">
                      <label className="input-group-text">CR14</label>
                      <input
                        name="cr14"
                        type="file"
                        className="form-control"
                        onChange={this.handleChange}
                        accept=".pdf,image/*"
                      />
                    </div>
                  </div>
                </>
              )}
            </div>
            {/* Document Upload Section */}
            <div className="w-100 mt-4" style={{ maxWidth: 62 + 'rem' }}>
              <div className="mb-4 p-4 bg-primary bg-opacity-10 border border-primary rounded">
                <h3 className="fw-bold text-primary mb-2">
                  <i className="bi bi-info-circle mr-2"></i>
                  Document Upload Instructions
                </h3>
                <ul className="text-primary small">
                  <li>• Accepted formats: PDF, JPG, JPEG, PNG, GIF</li>
                  <li>• Maximum file size: 10MB per document</li>
                  <li>• Ensure documents are clear and readable</li>
                  <li>• Each document uploads to its specific endpoint</li>
                </ul>
              </div>

              {(() => {
                const documentKeys = [
                  "individualNationalId",
                  "individualPassport",
                  "corporatePrimaryContactNationalId",
                  "corporatePrimaryContactPassport",
                  "corporateBillingContactNationalId",
                  "corporateBillingContactPassport",
                  "corporateCR14",
                  "corporateCertificateOfIncorporation",
                  "lawEnforcementNationalId",
                ];

                const visibleDocuments = documentKeys.filter((key) =>
                  this.shouldShowDocument(key)
                );

                if (visibleDocuments.length === 0) {
                  return (
                    <div className="text-center text-gray-500 mt-8">
                      <i className="bi bi-info-circle text-4xl mb-4"></i>
                      <p>No documents required for upload at this time.</p>
                    </div>
                  );
                }

                return visibleDocuments.map((documentKey) =>
                  this.renderDocumentField(documentKey)
                );
              })()}
            </div>

            <div className="d-flex justify-content-center gap-3 mt-2">
              {s.valid && (
                <button type="submit" className="btn btn-primary">
                  Update
                </button>
              )}
              <button
                type="button"
                className="btn btn-primary"
                onClick={this.props.onClose}
              >
                Cancel
              </button>
            </div>
          </form>
        </div>
      </div>
    );
  }
}
